import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { Modal } from "react-bootstrap";
import moment from 'moment';
import { v1 as uuid } from 'uuid'
import Select, { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';

import s_a from './common_arr/states-arr.js';
import formatNumber from '../common_component/formatNumber.js';
import country_arr from './common_arr/countries-arr.js';
import { setCookie, getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js";
import { useTheme } from "./theme-provider.js";
import { Link, useHistory } from 'react-router-dom';
import PageError from '../common_component/PageError.js';
import { Drawer, Button, Space, Timeline, Tooltip } from 'antd';
import StatusBadge from '../common_component/StatusBadge.js';

const loaderstyle = {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "auto",
    marginBottom: "auto",
};

let formatNumberOptions = {
    removeTrailingZeros: true
}

export const EditPaymentReceived = (props) => {
    const [state, setstate] = useState(2);
    const history = useHistory();
    const { theme, dropdownStyleDark } = useTheme()

    const [navtype, setnavtype] = useState("Overview");
    const [open, setOpen] = useState(false);
    const [customerInvoiceDetails, setCustomerInvoiceDetails] = useState(null);
    const [customerInvoiceHistoryDetails, setCustomerInvoiceHistoryDetails] = useState([]);
    const [additonalDetailsFlag, setAdditonalDetailsFlag] = useState(false);

    const [References, setReferences] = useState("");
    const [Payment_Type, setPayment_Type] = useState("Invoice Payment");
    const [approvalChainPopup, setApprovalChainPopup] = useState(false);

    const [selectedBillingAddress, setSelectedBillingAddress] = useState(null);
    const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);

    const [failedPageMessage, setFailedPageMessage] = useState("Something went wrong. Please reload this page.")

    const [addressList, setAddressList] = useState([])
    const [totalAddressList, setTotalAddressList] = useState([])
    const [addressListApiState, setAddressListApiState] = useState(false)

    const [invoiceArray, setInvoiceArray] = useState([]);
    const [default_acc, setDefault_acc] = useState({});

    const [newHead, setNewHead] = useState({ name: "", code: "", uq_ac: "", sub: 0, parent: "", description: "" })
    const [addAccHeadModalShow, setAddAccHeadModalShow] = useState(false)
    const [submitButton, SetSubmitButton] = useState(false)
    const [accountheadList, setAccountHeadList] = useState([])
    const [categoryList, setCategoryList] = useState([])
    const [tempAccountHeadList, setTempAccountHeadList] = useState([]);

    let [gstinList, setGstinList] = useState([]);
    const [totalGstinList, setTotalGstinList] = useState([])
    const [gstinListApiState, setGstinListApiState] = useState(false)
    const [gstInListModalShow, setGstInListModalShow] = useState(false);

    const [Configuration_obj, setConfiguration_obj] = useState({ denomination: [], Notes: "" });

    const [configurationindex, setconfigurationIndex] = useState(0);
    const [Currency_symbol, setCurrency_symbol] = useState("");
    const [Currency_code, setCurrency_code] = useState("");
    const [PaymentNumber, setPaymentNumber] = useState("");
    const [PaymentMode, setPaymentMode] = useState({ label: "Cash", value: "Cash" });
    const [PaymentModeList, setPaymentModeList] = useState([{ label: "Bank Transfer", value: "Bank Transfer" }, { label: "Cash", value: "Cash" }, { label: "Cheque", value: "Cheque" }, { label: "Credit Card", value: "Credit Card" }, { label: "Debit Card", value: "Debit Card" }, { label: "UPI", value: "UPI" }]);
    const [GSTINNumber, setGSTINNumber] = useState("");
    const [selectedPlaceOfSupply, setSelectedPlaceOfSupply] = useState(null);
    const [SelectedDestinationPlace, setSelectedDestinationPlace] = useState(null);
    const [SupplyStateOptions, setSupplyStateOptions] = useState([]);
    const [taxGroupList, setTaxGroupList] = useState([]);
    const [gstTreatmentlist, setgstTreatmentlist] = useState([{ label: "Registered Business-Regular", value: "Registered Business-Regular", description: "A business that is registered under GST" }, { label: "Registered Business-Composition", value: "Registered Business-Composition", description: "A business that is registered under composition scheme in GST" }, { label: "Unregistered Business", value: "Unregistered Business", description: "Business that has not been registered under GST" }, { label: "Consumer", value: "Consumer", description: "A customer who is regular consumer" }, { label: "Special Economic Zone", value: "Special Economic Zone", description: "Business that is located in a special economic zone" }, { label: "Deeemed Export", value: "Deeemed Export", description: "Supply of goods to an export oriented unit" }, { label: "SEZ Devloper", value: "SEZ Devloper", description: "An organization/person who owns atleast 26% of the equity in creating business units" }])
    const [paymentForList, setpaymentForList] = useState([{ label: "Customer", value: "Customer" }, { label: "Dealer", value: "Dealer" }]);
    const [ConfigurationModalShow, setConfigurationModalShow] = useState(false);
    const [advanceConfigurationModalShow, setAdvanceConfigurationModalShow] = useState(false);
    const [amtArray, setamtArray] = useState([]);
    const [Calculation_info, setCalculation_info] = useState({ total_amount: 0, adjustable_amount: 0, payment_amount: 0 });
    const [PaymentAmount, setPaymentAmount] = useState(0);

    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [baseCurrency, setBaseCurrency] = useState(null);
    const [referenceNumber, setReferenceNumber] = useState("");
    const [gstTreatment, setgstTreatment] = useState(null);
    const [paymentReceivedDetails, setPaymentReceivedDetails] = useState(null);
    const [paymentFor, setpaymentFor] = useState(null);
    const [paymentValue, setpaymentValue] = useState(null);
    const [DepositThroughAccount, setDepositThroughAccount] = useState(null)
    const [paymentValueList, setpaymentValueList] = useState([]);
    const [TotalpaymentValueList, setTotalpaymentValueList] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedTransactionSeries, setSelectedTransactionSeries] = useState(null);
    const [branchList, setBranchlist] = useState([]);
    const [transactionSeriesList, setTransactionSeriesList] = useState([]);
    const [DepositThroughAccountlist, setDepositThroughAccountlist] = useState([]);
    const [Notes, setNotes] = useState("");

    const [addressModalShow, setAddressModalShow] = useState(false)
    const [addressType, setAddressType] = useState(null)
    const [invoiceIndexAddress, setInvoiceIndexAddress] = useState(null)
    const [addressId, setAddressId] = useState(null)

    const [gstinModalShow, setGstinModalShow] = useState(false)
    const [invoiceIndexGstin, setInvoiceIndexGstin] = useState(null)
    const [gstinId, setGstinId] = useState(null)

    const [selectedAddress, setSelectedAddress] = useState(null);
    const [selectedGstin, setSelectedGstin] = useState(null)
    const [Payment_date, setPayment_date] = useState(moment().format('YYYY-MM-DD'));
    let [timezone_change, set_timezone_change] = useState("+00:00");
    const [PaymentUserApiState, setPaymentUserApiState] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const [currencyList, setCurrencyList] = useState([]);
    const [organizationDetails, setOrganizationDetails] = useState(null);
    const [baseExchangeRate, setBaseExchangeRate] = useState(0);
    const [currencyExchangeRates, setCurrencyExchangeRates] = useState(null);
    const [submitButtonState, setSubmitButtonState] = useState(false);

    const [copyIndex, setCopyIndex] = useState("")
    const [copyMode, setCopyMode] = useState("")
    const [copyData, setCopyData] = useState(null);

    const [invoiceIndexAdjustment, setInvoiceIndexAdjustment] = useState(0)
    const [invoiceIndexCurrency, setInvoiceIndexCurrency] = useState(null);
    const [advanceAdjustmentModalShow, setAdvanceAdjustmentModalShow] = useState(false);
    const [advancePaymentList, setAdvancePaymentList] = useState([]);

    const [gstInModalShow, setGstInModalShow] = useState(false);

    const [upsertGstInModalShow, setUpsertGstInModalShow] = useState(false);
    const [upsertGstInId, setUpsertGstInId] = useState("");
    const [upsertGstInTreatmentList, setUpsertGstInTreatmentList] = useState([{ label: "Registered Business-Regular", value: "Registered Business-Regular", description: "A business that is registered under GST" }, { label: "Registered Business-Composition", value: "Registered Business-Composition", description: "A business that is registered under composition scheme in GST" }, { label: "Special Economic Zone", value: "Special Economic Zone", description: "Business that is located in a special economic zone" }, { label: "Deeemed Export", value: "Deeemed Export", description: "Supply of goods to an export oriented unit" }, { label: "SEZ Devloper", value: "SEZ Devloper", description: "An organization/person who owns atleast 26% of the equity in creating business units" }])
    const [upsertGstInTreatment, setUpsertGstInTreatment] = useState(null)
    const [upsertGstInNumber, setUpsertGstInNumber] = useState("");
    const [upsertGstInLegalName, setUpsertGstInLegalName] = useState("");
    const [upsertGstInTradeName, setUpsertGstInTradeName] = useState("");
    const [upsertGstInSelectedPlaceOfSupply, setUpsertGstInSelectedPlaceOfSupply] = useState(null)
    const [upsertGstInSubmitButtonState, setUpsertGstInSubmitButtonState] = useState(false);
    const [ExpenseGstinList, setExpenseGstinList] = useState([]);

    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);

    const [creditcardlist, setCreditCardlist] = useState([{ label: "Visa", value: "Visa" }, { label: "MasterCard", value: "MasterCard" }, { label: "RuPay", value: "RuPay" }]);
    const [debitcardlist, setDebitCardlist] = useState([{ label: "lifestyle credit cards", value: "lifestyle credit cards" }, { label: "Travel credit cards", value: "Travel credit cards" }]);

    const [invoiceListApiState, setInvoiceListApiState] = useState(false)
    const [invoiceList, setInvoiceList] = useState([]);
    const [approvalInfo, setApprovalInfo] = useState(null);

    const apiController = useRef(new AbortController())

    var page_name = "edit-payment-received";

    const search_length = 1;

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    const readOnlyStyles = {
        backgroundColor: "lightgray",
        color: "gray",
        fontSize: "12px",
        border: "1px dotted gray",
        cursor: "text"
    }

    const trimDecimalPlaces = (amt, decimal_place) => {
        return Math.round(amt * Math.pow(10, decimal_place)) / Math.pow(10, decimal_place)
    }

    const onClose = () => {
        setOpen(false);
        setCustomerInvoiceDetails(null);
    };

    const checkDenominationValidation = (denominationArr, amount) => {
        const total_denomination = trimDecimalPlaces(denominationArr.reduce((p, o) => { return p + (o.count * parseInt(o.category)) }, 0), 3);
        if (total_denomination > Number(amount)) {
            swal("Oops!", "The total denomination cannot exceed the payment amount.", "warning");
            return false;
        }
        return true;
    }

    useEffect(() => {
        if (DepositThroughAccountlist.length > 0) {
            let cid = "";
            let hid = "";
            let hname = "";
            DepositThroughAccountlist.map((obj) => {
                obj.options.map((obj1) => {
                    if (obj1.label === "Petty Cash") {
                        cid = obj.id;
                        hid = obj1.value;
                        hname = obj1.label;
                        setDefault_acc({ label: hname, value: hid, category: cid });
                    }
                })
            });
        }

    }, [DepositThroughAccountlist])


    useEffect(() => {
        if ((selectedBranch != null) && (transactionSeriesList.length > 0)) {
            let tb = branchList.find(x => x.branch_id == selectedBranch.value);
            setSelectedTransactionSeries({ label: transactionSeriesList.find(x => x.transaction_series_id == tb.default_transaction_series).series_name, value: tb.default_transaction_series })
            //getSubSeriesData(selectedTransactionSeries.value,paymentFor.value);
        }
    }, [selectedBranch, transactionSeriesList, paymentFor])

    async function getInvoiceHistorydetails(val) {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-customer-invoice-history-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "customer_invoice_id": val, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            setCustomerInvoiceHistoryDetails(body.data);
        }
    }

    async function getFinalizeInvoiceListBySearch(search_val, val, user) {
        try {
            if (invoiceListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setInvoiceListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-finalized-invoice-payment-by-search`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_val, "user": user, "flag": val, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation == "success") {
                setInvoiceListApiState(false)
                setInvoiceList(body.data);
                return body.data;
            }
            else {
                throw "finalized invoice api list error"
            }
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getCustomerInvoiceDetails(id, flag) {
        setOpen(true);
        setAdditonalDetailsFlag(true);
        getInvoiceHistorydetails(id);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-customer-invoice-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "customer_invoice_id": id, "document_flag": true, "history_flag": true, "id": id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setCustomerInvoiceDetails(body.data[0]);
            setAdditonalDetailsFlag(false);
        }
        else {
            throw "Customer Invoice Details api error"
        }
    }

    async function getPaymentUser(search_value, key) {
        let api = "";
        if (key === "Customer") {
            api = "get-customer-by-search";
        }
        if (key === "Dealer") {
            api = "get-dealer-by-search";
        }

        setPaymentUserApiState(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/${api}`, {
                method: 'POST',
                body: JSON.stringify({
                    "email": user.email,
                    "search_value": search_value,
                    "page_name": page_name,
                    "organization_id": organization_id
                }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "token": getCookie("access_token")
                }
            }
            );
            const body = await response.json();

            if (body.operation === "success") {
                setTotalpaymentValueList(body.data.list);
                let value = body.data.list;
                value = value.map(x => ({
                    label: key === "Customer" ? x.customer_display_name : x.dealer_display_name,
                    value: x.cid
                }));

                setpaymentValueList(value);
                setPaymentUserApiState(false);
                return body.data.list;
            } else {
                throw new Error(`${key} list API error`);
            }
        } catch (error) {
            setPaymentUserApiState(false);
            console.error("Error fetching payment user:", error);
        }
    }

    async function getUserAddressDetails(val, key) {
        setAddressListApiState(true);
        let api = "";
        if (key == "Customer") {
            api = "get-customer-addresses";
        }
        if (key == "Dealer") {
            api = "get-dealer-addresses";
        }

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/${api}`, { method: 'POST', body: JSON.stringify({ "email": user.email, "cid": val, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if ((body.operation == "success") && (body.data.length > 0)) {
            console.log(body.data[0].address_details);
            setTotalAddressList(body.data[0].address_details);
            setAddressListApiState(false);
            body.data[0].address_details.find(x => x.address_type == "billing") && setSelectedBillingAddress(body.data[0].address_details.find(x => x.address_type == "billing"))
            body.data[0].address_details.find(x => x.address_type == "shipping") && setSelectedShippingAddress(body.data[0].address_details.find(x => x.address_type == "shipping"))
        }
        else {
            throw "address details api error"
        }
    }

    async function getPaymentUserGstinDetails(val, key) {
        setGstinListApiState(true);
        let api = "";
        if (key == "Customer") {
            api = "get-customer-tax-details";
        }
        if (key == "Dealer") {
            api = "get-dealer-tax-details";
        }
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/${api}`, { method: 'POST', body: JSON.stringify({ "email": user.email, "cid": val, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if ((body.operation == "success") && (body.data.length > 0)) {
            setTotalGstinList(body.data);
            setGstinListApiState(false);
            let t = body.data.find(x => x.flag == "Primary")
            if (t) {
                setSelectedGstin(t)
                setgstTreatment({ label: t.gst_treatment, value: t.gst_treatment });
                setGSTINNumber(t.GstIn);
                //setSelectedPlaceOfSupply({ label: t.place_of_supply, value: t.place_of_supply })
                setSelectedDestinationPlace({ label: t.place_of_supply, value: t.place_of_supply })
            }
            else {
                let temp = body.data
                temp.sort((a, b) => new Date(a.add_date_time) - new Date(b.add_date_time))
                let temp2 = temp[0]
                setSelectedGstin(temp2)
                setgstTreatment({ label: temp2.gst_treatment, value: temp2.gst_treatment });
                setGSTINNumber(temp2.GstIn);
                //setSelectedPlaceOfSupply({ label: temp2.place_of_supply, value: temp2.place_of_supply });
                setSelectedDestinationPlace({ label: temp2.place_of_supply, value: temp2.place_of_supply });
            }
            setExpenseGstinList(body.data);
        }
        else {
            throw "tax details api error"
        }
    }

    async function getCurrencies() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/currency-datatable`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.length != 0) {
            setCurrencyList(body.data)
        }
    }

    async function getBranchDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-branches`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation == "success") {
            setBranchlist(body.data);
            let temp = body.data.filter(option => option.default_branch == "yes")
            if (temp.length > 0) {
                setSelectedBranch({ label: temp[0].branch_name, value: temp[0].branch_id });
                setSelectedPlaceOfSupply({ label: temp[0].branch_address_state, value: temp[0].branch_address_state });
            }
        }
        else {
            throw "branch list api error"
        }
    }

    async function getTimezoneInformation() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-organization-timezone-information`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            if (body.data.length > 0) {
                if (body.data[0].timezone_value != "" && body.data[0].timezone_value != null) {
                    let timezone_change = body.data[0].timezone_value;
                    set_timezone_change(timezone_change);
                }
            }
        }
        else {
            throw "timezone api error"
        }
    }

    async function selectiveaccounthead(flag, name) {
        let arr = [
            { "category_name": "Assets", "headArray": [] },
            { "category_name": "Equity", "headArray": [] },
            { "category_name": "Liability", "headArray": [] },
            { "category_name": "Bank", "headArray": [] }
        ]
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/selective-account-head`, { method: 'POST', body: JSON.stringify({ "organization_id": organization_id, "headRequest": arr, "email": user.email, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            let temp_dropdown = body.data.map((obj) => ({
                label: obj.category_name,
                id: obj.cid,
                options: obj.headArray.map((obj1) => {
                    let temp_obj = { label: obj1.name, value: obj1.hid, code: obj1.code };
                    return temp_obj;
                })
            }));

            setDepositThroughAccountlist(temp_dropdown);
            setCategoryList(body.data);
        }
    }

    async function getOrganizationDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/show-organization`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.length != 0) {
            setOrganizationDetails(body.find(x => x.organization_id == getCookie("organization_id")))
        }
    }

    async function getApprovalDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-specific-approval`, {
            method: 'POST', body: JSON.stringify({ "organization_id": organization_id, "key": "payment_received_approval", "email": user.email, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") }
        }
        );
        const body = await response.json();
        if (body.operation === "success") {
            if (body.data !== null) {
                setApprovalInfo(body.data);
            }
        }
    }

    async function getTransactionSeriesList() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-transaction-series-list`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)
        if (body.operation == "success") {
            setTransactionSeriesList(body.data)
        }
        else {
            throw "transaction series api list error"
        }
    }

    async function getSubSeriesData(val, key) {
        let sub_series_name = "";
        if (key == "Customer") {
            sub_series_name = "customer_payment";
        }
        if (key == "Dealer") {
            sub_series_name = "dealer_payment";
        }

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-series-data-by-name`, { method: 'POST', body: JSON.stringify({ "email": user.email, "sub_series_name": sub_series_name, "transaction_series_id": val, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        //console.log(body.data)

        if (body.operation == "success") {
            setPaymentNumber(`${body.data.prefix_value}-${parseInt(body.data.last_count) + 1}`)
        }
        else {
            swal("Alert!", body.message, "warning")
            return false
        }
    }

    async function getPaymentDetails() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/payment-received-details`, {
            method: 'POST',
            body: JSON.stringify({
                "id": props.match.params.id,
                "email": user.email,
                "page_name": page_name,
                "organization_id": organization_id
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                "token": getCookie("access_token")
            }
        }
        );
        const body = await response.json();

        if ((body.operation === "success") && (body.data.length > 0)) {
            let info = body.data[0];
            if (info.add_status === "PAYMENT_DRAFT" || info.add_status === "PAYMENT_PENDING_APPROVAL") {
                setPaymentReceivedDetails(info);
                setpaymentFor({ label: info.payment_for, value: info.payment_for });
                setPayment_date(moment(info.payment_date).zone(timezone_change).format('YYYY-MM-DD'));
                setPayment_Type(info.payment_type);

                if (info.payment_type === "Advance Payment") {
                    setPaymentAmount(info.payment_amount);
                    const payment_received_currency = info.payment_received_currency;
                    setSelectedCurrency({
                        label: payment_received_currency.currency_code,
                        value: payment_received_currency.currency_id,
                        currency_symbol: payment_received_currency.currency_symbol,
                        format: payment_received_currency.format,
                        decimal_place: payment_received_currency.decimal_place
                    });
                } else {
                    const invoice_list = await getFinalizeInvoiceListBySearch("", info.payment_for, info.payment_user_id);
                    setInvoiceArray(info.invoice_info.map((obj) => {
                        let inv_d = invoice_list.find(x => x.invoice_id === obj.invoice_id);
                        const due_amount = inv_d !== undefined ? (Number(inv_d.invoice_amount) - Number(inv_d.paid_amount)) : 0;
                        return { ...obj, due_amount: due_amount, invoice_date: moment(obj.invoice_date).format('YYYY-MM-DD') };
                    }));
                }

                setAdvancePaymentList(info.advance_payment_list);

                // Pass info.payment_user_id directly here
                await getPaymentUser(info.payment_user_id, info.payment_for);

                getUserAddressDetails(info.payment_user_id, info.payment_for);
                getPaymentUserGstinDetails(info.payment_user_id, info.payment_for);
                setReferences(info.reference);
                setNotes(info.notes);
                setPaymentNumber(info.transaction_number);
            } else {
                throw new Error(`${body.data[0].transaction_number} is not allowed to edit`);
            }
        } else {
            throw new Error("No data is available");
        }
    }

    async function getCurrencyExchangeRates() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-live-currency`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        console.log(body)
        if (body.length != 0) {
            setCurrencyExchangeRates(body[0])
        }
    }

    useEffect(() => {
        if ((organizationDetails != null) && (currencyList.length > 0)) {
            let t = currencyList.find(x => x.currency_id == organizationDetails.currency)
            //setSelectedCurrency({ label: t.currency_code, value: t.currency_id, currency_symbol: t.currency_symbol,format: t.format, decimal_place: t.decimal_place });
            setBaseCurrency(t);
        }
    }, [organizationDetails, currencyList])

    useEffect(() => {
        if (paymentReceivedDetails !== null && categoryList.length > 0) {
            if (paymentReceivedDetails.payment_type === "Advance Payment") {
                categoryList.map((obj) => {
                    obj.headArray.map((obj1) => {
                        let temp_obj = { label: obj1.name, value: obj1.hid, code: obj1.code };
                        if (obj1.hid === paymentReceivedDetails.deposit_through_account && obj.cid === paymentReceivedDetails.deposit_through_account_category) {
                            setDepositThroughAccount(temp_obj);
                        }
                    })
                });

            }
        }

    }, [paymentReceivedDetails, categoryList])

    useEffect(() => {
        if (paymentReceivedDetails && branchList.length > 0 && transactionSeriesList.length > 0 && TotalpaymentValueList.length > 0) {

            // Match branch
            const matchedBranch = branchList.find(option => option.branch_id === paymentReceivedDetails.branch_id);
            if (matchedBranch) {
                setSelectedBranch({ label: matchedBranch.branch_name, value: paymentReceivedDetails.branch_id });
            }

            // Match Customer or Dealer using payment_user_id
            const matchedUser = TotalpaymentValueList.find(option => option.cid === paymentReceivedDetails.payment_user_id);
            if (matchedUser) {
                const displayName = paymentReceivedDetails.payment_for === "Dealer"
                    ? matchedUser.dealer_display_name
                    : matchedUser.customer_display_name;

                setpaymentValue({ label: displayName, value: paymentReceivedDetails.payment_user_id });
            }

            // Match transaction series
            const matchedSeries = transactionSeriesList.find(option => option.transaction_series_id === paymentReceivedDetails.transaction_series_id);
            if (matchedSeries) {
                setSelectedTransactionSeries({ label: matchedSeries.series_name, value: paymentReceivedDetails.transaction_series_id });
            }
        }
    }, [paymentReceivedDetails, branchList, transactionSeriesList, TotalpaymentValueList]);

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {
            let p1 = getTransactionSeriesList()
            let p2 = getBranchDetails()
            let p3 = getTimezoneInformation()
            let p4 = selectiveaccounthead("basic", "")
            let p5 = getCurrencies()
            let p6 = getOrganizationDetails()
            let p7 = getPaymentDetails()
            let p8 = getCurrencyExchangeRates()
            let p9 = getApprovalDetails()
            Promise.all([p1, p2, p3, p4, p5, p6, p7, p8, p9])
                .then(async () => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    setFailedPageMessage(err);
                    console.log(err)
                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (invoiceArray.length > 0 && invoiceArray.every(x => x.due_amount === 0)) {
            swal("Oops!", "All invoices for this record have been fully paid. You need to cancel the record.", "warning").then(() => { history.push("/payment-received-list") })
        }
    }, [invoiceArray])

    useEffect(() => {
        if (Payment_Type == "Invoice Payment" && invoiceArray.length > 0 && invoiceArray.every(invoice => invoice.invoice_number !== null)) {
            let total_amount = invoiceArray.reduce((p, o) => {
                if (!o.invoice_new) {
                    return p + ((Number(o.invoice_currency.exchange_rate.organization.rate) / Number(o.invoice_currency.exchange_rate.invoice.rate)) * Number(o.payment_amount))
                }
                else {
                    return p + Number(o.payment_amount);
                }
            }, 0);
            let adjustable_amount = invoiceArray.reduce((p1, o1) => {
                if (!o1.invoice_new) {
                    return p1 + o1.adjust_amount_arr.reduce((p2, o2) => { return p2 + (Number(o1.invoice_currency.exchange_rate.organization.rate) / Number(o1.invoice_currency.exchange_rate.invoice.rate)) * Number(o2.adjustable_balance) }, 0);
                }
                else {
                    return p1 + o1.adjust_amount_arr.reduce((p2, o2) => { return p2 + Number(o2.adjustable_balance) }, 0);
                }
            }, 0)
            let payment_amount = Number(total_amount) - Number(adjustable_amount);
            setCalculation_info({ "total_amount": total_amount, "adjustable_amount": adjustable_amount, "payment_amount": payment_amount });
        }
    }, [invoiceArray, Payment_Type])


    const Reset_Denomination = (val, type) => {
        if (val === "INR") {
            setamtArray([
                { "category": 2000, "count": 0, "amount": 0 },
                { "category": 500, "count": 0, "amount": 0 },
                { "category": 200, "count": 0, "amount": 0 },
                { "category": 100, "count": 0, "amount": 0 },
                { "category": 50, "count": 0, "amount": 0 },
                { "category": 20, "count": 0, "amount": 0 },
                { "category": 10, "count": 0, "amount": 0 },
                { "category": 5, "count": 0, "amount": 0 },
                { "category": 2, "count": 0, "amount": 0 },
                { "category": 1, "count": 0, "amount": 0 }
            ]);
        }
        else {
            setamtArray([
                { "category": 2000, "count": 0, "amount": 0 },
                { "category": 500, "count": 0, "amount": 0 },
                { "category": 200, "count": 0, "amount": 0 },
                { "category": 100, "count": 0, "amount": 0 },
                { "category": 50, "count": 0, "amount": 0 },
                { "category": 20, "count": 0, "amount": 0 },
                { "category": 10, "count": 0, "amount": 0 },
                { "category": 5, "count": 0, "amount": 0 },
                { "category": 2, "count": 0, "amount": 0 },
                { "category": 1, "count": 0, "amount": 0 }
            ]);
        }
    }

    const newHeadSubmit = () => {
        //Name check
        if (newHead.uq_ac == "") {
            swal("Warning!", "Select a Category", "warning");
            return
        }
        var nexp = /^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 \/\\&|@#()\\[\]_.,:"']*)?$/;
        //Name check
        if (newHead.name == "") {
            swal("Warning!", "Head must have name", "warning");
            return
        }
        if (!newHead.name.match(nexp)) {
            swal("Warning!", "Head name cannot contain a number or symbols", "warning");
            return
        }
        let flag = false
        accountheadList.map((head) => {
            if (head.name.trim().toLowerCase() == newHead.name.toLowerCase()) {
                flag = true
            }
        })
        if (flag) {
            swal("Warning!", "Name already exists", "warning");
            return
        }

        let flag2 = false
        categoryList.map((head) => {
            if (head.category_name.trim().toLowerCase() == newHead.name.toLowerCase()) {
                flag = true
            }
        })
        if (flag2) {
            swal("Warning!", "Name Cannot be same of any Category", "warning");
            return
        }

        //Code check
        if (newHead.code == "") {
            swal("Warning!", "Head must have a code", "warning");
            return
        }
        let flag3 = false
        accountheadList.map((head) => {
            if (head.code.trim().toLowerCase() == newHead.code.toLowerCase()) {
                flag3 = true
            }
        })
        if (flag3) {
            swal("Warning!", "Code name already take", "warning");
            return
        }
        //Sub Parent check
        if (newHead.sub && !String(newHead.parent).trim().length) {
            swal("Warning!", "Sub-Head must have a parent", "warning");
            return
        }
        if (!newHead.sub && String(newHead.parent).trim().length) {
            swal("Warning!", "non Sub-Head should have a parent", "warning");
            return
        }

        let object = { ...newHead, page_name: page_name, organization_id: organization_id };

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        SetSubmitButton(true)
        axios.post(`${process.env.REACT_APP_SERVER_URL}/add-account-head`, object, headers).then((res) => {
            SetSubmitButton(false)
            if (res.data.operation === "success") {
                swal("Great!", res.data.message, "success").then((value) => {
                    selectiveaccounthead("newly_added", newHead.name)
                    setAddAccHeadModalShow(false)
                });
            }
            else {
                swal("Oops!", res.data.message.substring(0, 30), "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const newGstInSubmit = () => {

        var object = {};

        if (upsertGstInNumber === null) {
            swal("Warning!", "GSTIN cannot be empty", "warning");
            return
        }
        if (upsertGstInLegalName === null) {
            swal("Warning!", "Business Legal Name cannot be empty", "warning");
            return
        }
        if (upsertGstInSelectedPlaceOfSupply === null) {
            swal("Warning!", "Supply place cannot be empty", "warning");
            return
        }

        object.GstIn = upsertGstInNumber;
        let api = "";
        if (paymentFor.value == "Customer") {
            object.dealer_id = paymentValue.value;
            api = "save-dealer-tax-details";
        }
        else if (paymentFor.value == "Dealer") {
            object.dealer_id = paymentValue.value;
            api = "save-dealer-tax-details";
        }

        object.gstTreatment = upsertGstInTreatment.value;
        object.place_of_supply = upsertGstInSelectedPlaceOfSupply.value;
        object.legal_name = upsertGstInLegalName;
        object.trade_name = upsertGstInTradeName;
        object.id = upsertGstInId;

        object.organization_id = organization_id;
        object.page_name = page_name;

        console.log(object)
        setUpsertGstInSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/save-dealer-tax-details`, object, headers).then((res) => {
            setUpsertGstInSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", "Gstin details updated successfully!", "success");
                setUpsertGstInModalShow(false);
                getPaymentUserGstinDetails(paymentValue.value);
                setUpsertGstInId("");
                setUpsertGstInTreatment(null)
                setUpsertGstInNumber("");
                setUpsertGstInLegalName("");
                setUpsertGstInTradeName("");
                setUpsertGstInSelectedPlaceOfSupply(null)
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const load_configuration_info = (val, index) => {
        let invoice_info = [...invoiceArray];
        invoice_info[index].payment_mode = val;
        if (val == "Cheque") {
            invoice_info[index].configuration_obj = { cheque_no: "", bank_name: "", cheque_date: "", notes: "" };
        }
        else if (val == "Bank Transfer") {
            invoice_info[index].configuration_obj = { date: "", bank_name: "", transaction_id: "", notes: "" };
        }
        else if (val == "Credit Card") {
            invoice_info[index].configuration_obj = { card_no: "", card_holder_name: "", expiry_date: "", notes: "" };
        }
        else {
            Reset_Denomination(baseCurrency.currency_code, "Set");
            invoice_info[index].configuration_obj = { denomination: [], notes: "" };
        }
        setInvoiceArray(invoice_info);
        setconfigurationIndex(index);
    }


    useEffect(() => {
        let state_arr = s_a.s_a[country_arr.country_arr.findIndex((obj) => obj == "India")].split("|");
        let obj_array = [];
        for (let i = 0; i < state_arr.length; i++) {
            obj_array.push({ value: state_arr[i], label: state_arr[i] });
        }
        setSupplyStateOptions(obj_array);
    }, []);

    useEffect(() => {
        if (paymentValue !== null && Payment_Type !== null && paymentReceivedDetails !== null) {
            let object = {};
            var headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "*/*",
                    "token": getCookie("access_token")
                }
            }
            object.organization_id = organization_id;
            object.page_name = page_name;
            object.payment_user_id = paymentValue.value;
            axios.post(`${process.env.REACT_APP_SERVER_URL}/check-user-wise-advance-payment-list`, object, headers).then((res) => {
                if (res.data.operation === "success") {
                    let temp_arr = [];
                    res.data.data.map((obj) => {
                        temp_arr.push({ Payment_id: obj.transaction_number, adjustable_balance: 0, available_balance: obj.available_amount, total_balance: obj.payment_amount, payment_received_currency: (obj.payment_received_currency) });
                    })
                    setAdvancePaymentList(temp_arr);
                }
            })
        }
    }, [paymentValue, Payment_Type, paymentReceivedDetails]);

    const newPaymentSubmit = (val) => {
        var object = {};

        object.organization_id = organization_id;
        object.paymentFor = paymentFor.value;
        object.payment_type = Payment_Type;
        object.payment_user_id = paymentValue.value;
        object.branch_id = selectedBranch.value;
        object.transaction_series_id = selectedTransactionSeries.value;
        object.payment_number = PaymentNumber;
        object.payment_date = new Date(Payment_date);
        object.invoice = referenceNumber.trim();
        object.notes = Notes;
        if (Payment_Type == "Advance Payment") {
            object.billing_address = selectedBillingAddress;
            object.shipping_address = selectedShippingAddress;
            object.tax_details = selectedGstin;
            object.deposit_through_account = DepositThroughAccount.value;
            object.deposit_through_account_category = DepositThroughAccountlist.find(x => x.options.map(a => a.value).includes(DepositThroughAccount.value)).id;
            object.payment_mode = PaymentMode.value;
            object.configuration_obj = Configuration_obj;
            object.payment_amount = PaymentAmount;
            let org_c_code = selectedCurrency.label
            let org_c_rate = (org_c_code == "USD") ? 1 : currencyExchangeRates.data.quotes["USD" + org_c_code]
            let ord_c_rate = (selectedCurrency.label == "USD") ? 1 : currencyExchangeRates.data.quotes["USD" + selectedCurrency.label]
            let exchange_rate = {
                organization: { base_curr: "USD", quote_curr: org_c_code, rate: org_c_rate },
                payment_received: { base_curr: "USD", quote_curr: selectedCurrency.label, rate: ord_c_rate },
            }

            let ic = currencyList.find(x => x.currency_id == selectedCurrency.value)
            object.payment_received_currency = { currency_id: ic.currency_id, currency_symbol: ic.currency_symbol, currency_code: ic.currency_code, format: ic.format, decimal_place: ic.decimal_place, exchange_rate: exchange_rate }
        }
        else {
            object.invoice_info = invoiceArray;
        }

        object.advance_payment_list = advancePaymentList.filter(elem => elem.adjustable_balance > 0);
        object.Calculation_info = Calculation_info;
        object.id = props.match.params.id;
        object.page_name = page_name;
        //object.Currency_conversion_value = Currency_conversion_value;
        object.flag = Payment_Type;
        object.save_flag = val
        object.organization_id = organization_id
        object.page_name = page_name;

        //console.log(object);
        setSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-payment-received`, object, headers).then((res) => {
            setSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", `Payment received details updated successfully!`, "success").then((value) => { window.location.href = `/payment-received-list` });
            }
            else if (res.data.operation === "danger" && res.data.message === "not modified") {
                swal("Oops!", "need to modify something for updation!!", "error");
            }
            else if (res.data.message === "invoice_already_paid") {
                swal("Oops!", `This ${res.data.data.join(",")} Invoice Number already paid. Please remove this invoice before proceeding!!`, "error");
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const validatePayment = () => {
        if (paymentFor == null) {
            swal("Oops!", "Choose an Payment For", "error");
            return
        }
        if (paymentValue == null) {
            swal("Oops!", `Customer Name field cannot be empty.`, "error");
            return
        }
        if (PaymentNumber == "") {
            swal("Oops!", `Transaction number can't be null`, "error");
            return
        }
        if (Payment_Type === "Advance Payment") {
            if (PaymentAmount === 0) {
                swal("Oops!", `Payment Amount should be greater than zero.`, "error");
                return
            }
        }
        if (Payment_Type !== "Advance Payment") {
            if (Calculation_info.payment_amount <= 0) {
                swal("Oops!", `Payment Amount should be greater than zero.`, "error");
                return
            }
            for (let i = 0; i < invoiceArray.length; i++) {
                let obj = invoiceArray[i]
                if (obj.invoice_number == null) {
                    swal("Oops!", "Choose or Create an Invoice", "error");
                    return
                }
                if (obj.invoice_date == "") {
                    swal("Oops!", `Enter an Invoice Date (${obj.invoice_number})`, "error");
                    return
                }
                if (Number(obj.invoice_amount) == 0) {
                    swal("Oops!", "Invoice amount should be greater than zero", "error");
                    return
                }
                if (obj.invoice_id !== null && obj.due_amount == 0) {
                    swal("Oops!", `The due amount is already zero. Please remove this invoice - (${obj.invoice_number}) before proceeding.`, "error");
                    return
                }
                if (obj.payment_amount == 0) {
                    swal("Oops!", `Payment amount must be greater than zero - (${obj.invoice_number})`, "error");
                    return
                }
                if (obj.payment_amount > obj.due_amount) {
                    swal("Oops!", `Payment cannot exceed the due amount - (${obj.invoice_number})`, "error");
                    return
                }
            }
        }
        return true
    }

    const clear_invoice_details = () => {
        let temp = invoiceArray.map(x => { return { ...x } });
        temp.map((obj, index) => {
            obj.invoice_number = null
            obj.invoice_id = null
            obj.invoice_date = ""
            obj.invoice_amount = 0
            obj.due_amount = 0
            obj.payment_amount = 0
            obj.invoice_new = true
            obj.billing_address = null
            obj.shipping_address = null
            obj.gstin_details = null
            obj.invoice_currency = baseCurrency
            obj.adjust_amount_arr = [];
            obj.currency_rate = (baseCurrency.currency_code == "USD") ? 1 : currencyExchangeRates.data.quotes["USD" + baseCurrency.currency_code]
        })
        setInvoiceArray(temp);
    }

    const pay_full_amount = (obj, index, type) => {
        let temp = invoiceArray.map(x => { return { ...x } });
        if (type === "individual") {
            if (obj.due_amount > 0) {
                temp[index].payment_amount = obj.due_amount;
            }
            else {
                temp[index].payment_amount = obj.invoice_amount;
            }
        }
        setInvoiceArray(temp);
    }

    const handleAddressModalClose = () => {
        setAddressModalShow(false)
        setAddressType(null)
        setInvoiceIndexAddress(null)
        setAddressId(null)
    }

    const handleGstinModalClose = () => {
        setGstinModalShow(false)
        setInvoiceIndexGstin(null)
        setGstinId(null)
    }

    const Config_set_up = (val) => {
        if (val == "Cheque") {
            setConfiguration_obj({ cheque_no: "", bank_name: "", cheque_date: "", Notes: "" });
        }
        else if (val == "Bank_Transfer") {
            setConfiguration_obj({ date: "", bank_name: "", transaction_id: "", Notes: "" });
        }
        else if (val == "Credit_Card") {
            setConfiguration_obj({ card_no: "", card_holder_name: "", expiry_date: "", Notes: "" });
        }
        else {
            Reset_Denomination(baseCurrency.currency_code, "Set");
            setConfiguration_obj({ Denomination: [], Notes: "" });
        }
    }

    const resetAdvanceAdjustment = () => {
        let advanceArr = advancePaymentList.map(x => { return { ...x } });
        advanceArr.forEach((obj) => {
            obj.adjustable_balance = 0;
            //obj.available_balance = obj.total_balance;
        })
        setAdvancePaymentList(advanceArr);
        let invoiceArr = invoiceArray.map(x => { return { ...x } })
        invoiceArr[invoiceIndexAdjustment].adjust_amount_arr = [];
        setInvoiceArray(invoiceArr);
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Edit Payment Details</h1>
                    <Tooltip title="SpotERP Docs" >
                        <a
                            href={`${process.env.REACT_APP_SPOTERP_DOCS}/sales/receive_payment`}
                            className='btn btn-light-primary py-2 px-3'
                            target="_blank"
                        >
                            <i className="bi bi-journal-text fs-1 px-0"></i>
                        </a>
                    </Tooltip>
                </div>
                <div>
                    {
                        ((!approvalInfo || approvalInfo.type === "not_configure") && state === 1) &&
                        <>
                            <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed  p-6">
                                <span className="svg-icon svg-icon-2tx svg-icon-warning me-4"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                    <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="currentColor"></rect>
                                    <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="currentColor"></rect>
                                </svg>
                                </span>
                                <div className="d-flex flex-stack flex-grow-1 ">
                                    <div className=" fw-semibold">
                                        <div className="fs-6 text-gray-700 ">Payment Received Approval Part Not Configured yet. Configure this, From <Link to={"/approvals"}>Approval Page</Link>.</div>
                                    </div>
                                </div>
                            </div><br />
                        </>
                    }
                    <div className="card">
                        <div className="card-body pt-6">
                            {
                                state == 1 ?
                                    <>
                                        <div className="row mb-sm-5 gx-0 ">
                                            {/* <div className="col-md-4 px-1 mb-2">
                                                    <label className="required fs-5 fw-bold mb-2">Payment For</label>
                                                    <Select
                                                        options={paymentForList}
                                                        onChange={(val) => {
                                                            setpaymentFor(val);
                                                            setpaymentValue(null);
                                                            getPaymentUser("", val.value);
                                                            getSubSeriesData(selectedTransactionSeries.value, val.value);
                                                            clear_invoice_details();
                                                        }}
                                                        value={paymentFor}
                                                        styles={theme =='dark' ? dropdownStyleDark : {}}
                                                        isDisabled={true}
                                                    />
                                                </div> */}
                                            {paymentFor !== null &&
                                                <div className="col-md-4 px-1 mb-2">
                                                    <label className="required fs-5 fw-bold mb-2">{paymentFor.value} Name</label>
                                                    <Select
                                                        options={paymentValueList}
                                                        onChange={(val) => {
                                                            setpaymentValue(val);
                                                            getFinalizeInvoiceListBySearch("", paymentFor.value, val.value);
                                                            getPaymentUserGstinDetails(val.value, paymentFor.value);
                                                            getUserAddressDetails(val.value, paymentFor.value);
                                                            clear_invoice_details();
                                                        }}
                                                        value={paymentValue}
                                                        styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                        isDisabled={true}
                                                    />
                                                </div>}
                                            <div className="col-md-4">
                                                <label className="required fs-5 fw-bold mb-2">Payment Date</label>
                                                <input type="date" className="form-control" placeholder="Sales Start Date" value={Payment_date}
                                                    onChange={(e) => {
                                                        setPayment_date(e.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        {Payment_Type == "Advance Payment" &&
                                            <>
                                                <div className="row gx-0" style={{ transition: "all 1s ease-in-out", opacity: paymentValue != null ? "1" : "0", visibility: paymentValue != null ? "visible" : "hidden", height: paymentValue != null ? "auto" : "0", marginBottom: paymentValue != null ? "1rem" : "0" }} >
                                                    <div className="col-md-6 px-1">
                                                        <div className="card card-dashed p-6 flex-row">
                                                            <div className="d-flex flex-column flex-grow-1">
                                                                <div className="d-flex align-items-center fs-5 fw-bold mb-5">Billing Address</div>
                                                                {
                                                                    selectedBillingAddress != null ?
                                                                        <>
                                                                            {(selectedBillingAddress.address_line1 != "" && selectedBillingAddress.address_line2 != "") && <div className="fs-6 fw-semibold text-gray-600">{`${selectedBillingAddress.address_line1} ${selectedBillingAddress.address_line2}`}</div>}
                                                                            <div className="fs-6 fw-semibold text-gray-600">{`${selectedBillingAddress.city} ${selectedBillingAddress.state}, ${selectedBillingAddress.pincode} ${selectedBillingAddress.country}`}</div>
                                                                        </>
                                                                        :
                                                                        <div className='text-hover-primary'>Select an address</div>
                                                                }
                                                            </div>
                                                            <div className="d-flex align-items-center">
                                                                <button onClick={(e) => { setAddressModalShow(true); setAddressId(selectedBillingAddress == null ? null : selectedBillingAddress.id); setAddressList(totalAddressList); setAddressType("billing") }} className="btn btn-sm px-3">
                                                                    <i className="fa-solid fa-pencil fs-2 text-hover-success"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6 px-1">
                                                        <div className="card card-dashed p-6 flex-row">
                                                            <div className="d-flex flex-column flex-grow-1">
                                                                <div className="d-flex align-items-center fs-5 fw-bold mb-5">Shipping Address</div>
                                                                {
                                                                    selectedShippingAddress != null ?
                                                                        <>
                                                                            {(selectedShippingAddress.address_line1 != "" && selectedShippingAddress.address_line2 != "") && <div className="fs-6 fw-semibold text-gray-600">{`${selectedShippingAddress.address_line1} ${selectedShippingAddress.address_line2}`}</div>}
                                                                            <div className="fs-6 fw-semibold text-gray-600">{`${selectedShippingAddress.city} ${selectedShippingAddress.state}, ${selectedShippingAddress.pincode} ${selectedShippingAddress.country}`}</div>
                                                                        </>
                                                                        :
                                                                        <div className='text-hover-primary'>Select an address</div>
                                                                }
                                                            </div>
                                                            <div className="d-flex align-items-center">
                                                                <button onClick={(e) => { setAddressModalShow(true); setAddressId(selectedShippingAddress == null ? null : selectedShippingAddress.id); setAddressList(totalAddressList); setAddressType("shipping") }} className="btn btn-sm px-3">
                                                                    <i className="fa-solid fa-pencil fs-2 text-hover-success"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row gx-0" style={{ transition: "all 1s ease-in-out", opacity: paymentValue != null ? "1" : "0", visibility: paymentValue != null ? "visible" : "hidden", height: paymentValue != null ? "auto" : "0", marginBottom: paymentValue != null ? "1rem" : "0" }} >
                                                    <div className="col-12">
                                                        <div className="bg-light-primary border border-primary d-flex flex-column w-100 p-5 rounded">
                                                            <h5>GSTIN Details</h5>
                                                            <div className="d-flex flex-wrap align-items-center gap-1">
                                                                {
                                                                    selectedGstin != null ?
                                                                        <>
                                                                            <div className="border border-gray-300 border-dashed rounded min-w-100px py-2 px-4 mx-3 flex-grow-1">
                                                                                <span className="fs-6 text-gray-700 fw-bold">{selectedGstin.gst_treatment}</span>
                                                                                <div className="fw-semibold text-gray-400">GST Treatment</div>
                                                                            </div>
                                                                            {selectedGstin.gst_treatment == "Registered Business" &&
                                                                                <div className="border border-gray-300 border-dashed rounded min-w-100px py-2 px-4 mx-3 flex-grow-1">
                                                                                    <span className="fs-6 text-gray-700 fw-bold">{selectedGstin.GstIn}</span>
                                                                                    <div className="fw-semibold text-gray-400">GSTIN</div>
                                                                                </div>}
                                                                        </> :
                                                                        <div className="border border-gray-300 border-dashed rounded min-w-100px py-2 px-4 mx-3 flex-grow-1">
                                                                            <span className="fs-6 text-gray-700 fw-bold">No GSTIN selected</span>
                                                                        </div>
                                                                }
                                                                <div>
                                                                    <button onClick={(e) => { setGstinModalShow(true); setGstinId(selectedGstin == null ? null : selectedGstin.unique_id); setGstinList(totalGstinList); }} className="btn btn-sm px-3">
                                                                        <i className="fa-solid fa-pencil fs-2 text-hover-success"></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }

                                        <div className="row mb-sm-5 gx-0 ">
                                            <div className="col-md-4 px-1 mb-2">
                                                <label className="required fs-5 fw-bold mb-2">Branch:</label>
                                                <Select
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    options={branchList.map((x) => { return { label: x.branch_name, value: x.branch_id } })}
                                                    onChange={(val) => {
                                                        swal("Alert!", "Please verify applicable taxes for selected items", "info")
                                                        setSelectedBranch(val);
                                                        setSelectedTransactionSeries(null)
                                                    }}
                                                    value={selectedBranch}
                                                    placeholder="Select Branch"
                                                    isDisabled={true}
                                                />
                                            </div>
                                            <div className="col-md-4 px-1 mb-2">
                                                <label className="required fs-5 fw-bold mb-2">Transaction Series:</label>
                                                <Select
                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                    style={readOnlyStyles}
                                                    options={selectedBranch != null && transactionSeriesList.filter(x => branchList.find(a => a.branch_id == selectedBranch.value).transaction_series_id.split(",").includes(x.transaction_series_id)).map(x => { return { label: x.series_name, value: x.transaction_series_id } })}
                                                    onChange={(val) => { setSelectedTransactionSeries(val); getSubSeriesData(val.value, paymentFor.value) }}
                                                    value={selectedTransactionSeries}
                                                    placeholder="Select Transaction Series"
                                                    isDisabled={true}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="required fs-5 fw-bold mb-2">Transaction Number</label>
                                                <input type="text" className="form-control form-control-solid" value={PaymentNumber} readOnly />
                                            </div>
                                        </div>
                                        {Payment_Type == "Advance Payment" &&
                                            <>
                                                <div className="row mb-5">
                                                    <div className="col-md-6">
                                                        <label className="required fs-5 fw-bold mb-2">Deposit Through</label>
                                                        <Select
                                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                            options={DepositThroughAccountlist}
                                                            onChange={(event) => { setDepositThroughAccount(event); }}
                                                            value={DepositThroughAccount}
                                                            components={{
                                                                MenuList: (props) => {
                                                                    return (
                                                                        <components.MenuList  {...props}>
                                                                            {props.children}
                                                                            <div className='d-flex justify-content-center'>
                                                                                <button className='btn btn-success rounded btn-sm my-1' onClick={() => { setAddAccHeadModalShow(true) }} >&#10011; Add  Account head</button>
                                                                            </div>
                                                                        </components.MenuList >
                                                                    )
                                                                }
                                                            }}
                                                        //isDisabled={Payment_Type === "Advance Payment"}
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="fs-5 fw-bold mb-2">Payment Mode</label>
                                                        <Select
                                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                            style={readOnlyStyles}
                                                            options={PaymentModeList}
                                                            onChange={(val) => { Config_set_up(val.value); setPaymentMode(val) }}
                                                            value={PaymentMode}
                                                            disabled
                                                        //isClearable
                                                        />
                                                        {PaymentAmount > 0 &&
                                                            <a className="cursor-pointer" onClick={(e) => { setAdvanceConfigurationModalShow(true); }}>{PaymentMode != null && <span className="text-primary fs-6">Configure {PaymentMode.label} Mode</span>}</a>}
                                                    </div>
                                                </div>
                                            </>
                                        }

                                        <div className="row mb-5">
                                            {Payment_Type == "Advance Payment" &&
                                                <>
                                                    <div className="col-md-3">
                                                        <label className="fs-5 fw-bold mb-2 required">Currency</label>
                                                        <Select
                                                            options={currencyList.map(x => { return { label: x.currency_code, value: x.currency_id, currency_symbol: x.currency_symbol, format: x.format, decimal_place: x.decimal_place } })}
                                                            onChange={(val) => { setSelectedCurrency(val) }}
                                                            value={selectedCurrency}
                                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="required fs-5 fw-bold mb-2">Amount</label>
                                                        <div className="input-group input-group-solid mb-5">
                                                            <span className="input-group-text">{selectedCurrency.currency_symbol}</span>
                                                            <input type="number" className="form-control" value={PaymentAmount.toString()} min="0"
                                                                onChange={(e) => { setPaymentAmount(e.target.value == "" ? 0 : parseFloat(e.target.value)); }}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            <div className="col-md-6">
                                                <label className="fs-6 fw-semibold mb-2">Payment Type</label>
                                                <div className="d-flex align-items-center">
                                                    {Payment_Type == "Invoice Payment" && <div className={`rounded mx-2 px-6 py-2 cursor-pointer ${Payment_Type == "Invoice Payment" && "bg-primary"}`} onClick={() => { setPayment_Type("Invoice Payment"); }}>Invoice Payment</div>}
                                                    {Payment_Type == "Advance Payment" && <div className={`rounded mx-2 px-6 py-2 cursor-pointer ${Payment_Type == "Advance Payment" && "bg-primary"}`} onClick={() => { setPayment_Type("Advance Payment"); }}>Advance Payment</div>}
                                                </div>
                                            </div>
                                        </div>
                                        <hr />

                                        <div className="table-responsive">
                                            {Payment_Type == "Invoice Payment" &&
                                                <>
                                                    <div className='container-fluid'>
                                                        {
                                                            invoiceArray.map((obj, i) => {
                                                                return (
                                                                    <div key={i} className='container bg-secondary my-2 p-5 rounded'>
                                                                        <div className='d-flex align-items-center justify-content-between mb-3'>
                                                                            <div className="d-flex align-items-center gap-2 gap-lg-3">
                                                                                <div className='fs-4 fw-bold'>Invoice: #{i + 1}
                                                                                    {(obj.invoice_id !== null && obj.due_amount == 0) && <span className="text-danger ms-5">This invoice has been fully paid. Please remove it.</span>}
                                                                                </div>
                                                                                {(obj.invoice_id !== null && invoiceList.find(x => x.invoice_id == obj.invoice_id) !== undefined) &&
                                                                                    <>
                                                                                        {/* <a class="cursor-pointer" onClick={() => { getCustomerInvoiceDetails(obj.invoice_id, "payment_log") }}><span class="badge py-3 px-4 fs-7 badge-light-warning">Pending: {obj.invoice_currency.currency_symbol} {invoiceList.find(x => x.invoice_id == obj.invoice_id).pending_amount}</span></a> */}
                                                                                        <a class="cursor-pointer" onClick={() => { getCustomerInvoiceDetails(obj.invoice_id, "payment_log") }}><span class="badge py-3 px-4 fs-7 badge-light-success">Paid Amount: {obj.invoice_currency.currency_symbol} {invoiceList.find(x => x.invoice_id == obj.invoice_id).paid_amount}</span></a>
                                                                                    </>
                                                                                }
                                                                            </div>
                                                                            {/* <div>
                                                                                    <button className={`btn btn-link text-hover-success mx-2 ${obj.billing_address == null && "required"}`}
                                                                                        onClick={() => {
                                                                                            if (paymentFor == null) {
                                                                                                swal("Oops!", `Select payment for field first`, "warning")
                                                                                                return
                                                                                            }
                                                                                            if (paymentValue == null) {
                                                                                                swal("Oops!", `Select a ${paymentFor.value} first`, "warning")
                                                                                                return
                                                                                            }
                                                                                            if (obj.invoice_number == null) {
                                                                                                swal("Oops!", `Select Invoice No. first`, "warning")
                                                                                                return
                                                                                            }
                                                                                            else {
                                                                                                if (obj.invoice_new) {
                                                                                                    setAddressList(totalAddressList);
                                                                                                }
                                                                                                else {
                                                                                                    setAddressList(obj.billing_address == null ? [] : [obj.billing_address]);
                                                                                                }
                                                                                            }
                                                                                            setInvoiceIndexAddress(i);
                                                                                            setAddressId(obj.billing_address == null ? null : obj.billing_address.id);
                                                                                            setAddressType("billing");
                                                                                            setAddressModalShow(true);
                                                                                        }}
                                                                                    >
                                                                                        <i className="fa-solid fs-2 px-0 fa-house"></i>
                                                                                    </button>
                                                                                    <button className={`btn btn-link text-hover-success mx-2 ${obj.shipping_address == null && "required"}`}
                                                                                        onClick={() => {
                                                                                            if (paymentFor == null) {
                                                                                                swal("Oops!", `Select payment for field first`, "warning")
                                                                                                return
                                                                                            }
                                                                                            if (paymentValue == null) {
                                                                                                swal("Oops!", `Select a ${paymentFor.value} first`, "warning")
                                                                                                return
                                                                                            }
                                                                                            //getUserAddressDetails(paymentValue.value,paymentFor.value);
                                                                                            //console.log(addressListApiState);
                                                                                            //console.log(totalAddressList);
                                                                                            if (obj.invoice_number == null) {
                                                                                                swal("Oops!", `Select Invoice No. first`, "warning")
                                                                                                return
                                                                                            }
                                                                                            else {
                                                                                                if (obj.invoice_new) {
                                                                                                    setAddressList(totalAddressList);
                                                                                                }
                                                                                                else {
                                                                                                    setAddressList(obj.shipping_address == null ? [] : [obj.shipping_address]);
                                                                                                }
                                                                                            }
                                                                                            setInvoiceIndexAddress(i);
                                                                                            setAddressId(obj.shipping_address == null ? null : obj.shipping_address.id);
                                                                                            setAddressType("shipping");
                                                                                            setAddressModalShow(true);
                                                                                        }}
                                                                                    >
                                                                                        <i className="fa-solid fs-2 px-0 fa-truck"></i>
                                                                                    </button>
                                                                                    <button className={`btn btn-link text-hover-success mx-2 ${obj.gstin_details == null && "required"}`}
                                                                                        onClick={() => {
                                                                                            if (paymentFor == null) {
                                                                                                swal("Oops!", `Select payment for field first`, "warning")
                                                                                                return
                                                                                            }
                                                                                            if (paymentValue == null) {
                                                                                                swal("Oops!", `Select a ${paymentFor.value} first`, "warning")
                                                                                                return
                                                                                            }
                                                                                            if (obj.invoice_number == null) {
                                                                                                swal("Oops!", `Select Invoice No. first`, "warning")
                                                                                                return
                                                                                            }
                                                                                            else {
                                                                                                if (obj.invoice_new) {
                                                                                                    setGstinList(totalGstinList);
                                                                                                }
                                                                                                else {
                                                                                                    setGstinList([obj.gstin_details]);
                                                                                                }
                                                                                            }
                                                                                            //getPaymentUserGstinDetails(obj.dealer_id);
                                                                                            setInvoiceIndexGstin(i);
                                                                                            setGstinId(obj.gstin_details == null ? null : obj.gstin_details.unique_id);
                                                                                            setGstinModalShow(true);
                                                                                        }}
                                                                                    >
                                                                                        <i className="fa-solid fs-2 px-0 fa-coins"></i>
                                                                                    </button>
                                                                                    {
                                                                                        invoiceArray.length > 1 &&
                                                                                        <button className='btn btn-link text-hover-danger mx-3'
                                                                                            onClick={() => {
                                                                                                let t = invoiceArray.map(x => { return { ...x } })
                                                                                                t.splice(i, 1)
                                                                                                setInvoiceArray(t)
                                                                                            }}
                                                                                        >&#10006;</button>
                                                                                    }
                                                                                </div> */}

                                                                        </div>

                                                                        <div className="row mb-5 gx-0 ">
                                                                            <div className="col-md-4 px-1 mb-2">
                                                                                <label className="fs-5 fw-bold mb-2 required">Invoice No.</label>
                                                                                <CreatableSelect
                                                                                    options={invoiceList.map(x => { return { label: x.invoice_number, value: x.invoice_id } })}
                                                                                    value={obj.invoice_number == null ? null : { label: obj.invoice_number, value: obj.invoice_id }}
                                                                                    onChange={(val) => {
                                                                                        if (invoiceArray.find(a => a.invoice_number == val.label) !== undefined) {
                                                                                            swal("Warning!", "Invoice already selected", "warning");
                                                                                            return
                                                                                        }
                                                                                        else {
                                                                                            if (val.hasOwnProperty("__isNew__") && val["__isNew__"] == true) {
                                                                                                let t = invoiceArray.map(x => { return { ...x } })
                                                                                                t[i].invoice_number = val.label
                                                                                                t[i].invoice_id = null
                                                                                                t[i].invoice_date = ""
                                                                                                t[i].invoice_amount = 0
                                                                                                t[i].due_amount = 0
                                                                                                t[i].payment_amount = 0
                                                                                                t[i].invoice_new = true
                                                                                                t[i].billing_address = null
                                                                                                t[i].shipping_address = null
                                                                                                t[i].gstin_details = null
                                                                                                t[i].invoice_currency = baseCurrency
                                                                                                t[i].currency_rate = (baseCurrency.currency_code == "USD") ? 1 : currencyExchangeRates.data.quotes["USD" + baseCurrency.currency_code]
                                                                                                setInvoiceArray(t);
                                                                                            }
                                                                                            else {
                                                                                                let inv_d = invoiceList.find(x => x.invoice_id == val.value)
                                                                                                const due_amount = Number(inv_d.invoice_amount) - Number(inv_d.paid_amount);
                                                                                                if (due_amount > 0) {
                                                                                                    let t = invoiceArray.map(x => { return { ...x } })
                                                                                                    const invoice_currency = typeof (inv_d.invoice_currency) == "string" ? JSON.parse(inv_d.invoice_currency) : inv_d.invoice_currency;
                                                                                                    t[i].invoice_number = val.label
                                                                                                    t[i].invoice_id = val.value
                                                                                                    t[i].invoice_amount = inv_d.grand_total
                                                                                                    t[i].due_amount = due_amount > 0 ? due_amount : 0
                                                                                                    t[i].payment_amount = due_amount
                                                                                                    t[i].invoice_date = moment(inv_d.invoice_date).format("YYYY-MM-DD")
                                                                                                    t[i].invoice_new = false
                                                                                                    t[i].billing_address = typeof (inv_d.billing_address) == "string" ? JSON.parse(inv_d.billing_address) : inv_d.billing_address
                                                                                                    t[i].shipping_address = typeof (inv_d.shipping_address) == "string" ? JSON.parse(inv_d.shipping_address) : inv_d.shipping_address
                                                                                                    t[i].gstin_details = typeof (inv_d.gstin_details) == "string" ? JSON.parse(inv_d.gstin_details) : inv_d.gstin_details
                                                                                                    t[i].invoice_currency = invoice_currency
                                                                                                    t[i].currency_rate = (invoice_currency.currency_code == "USD") ? 1 : currencyExchangeRates.data.quotes["USD" + baseCurrency.currency_code]

                                                                                                    setInvoiceArray(t);
                                                                                                }
                                                                                                else {
                                                                                                    swal("Oops!", `This invoice can't select because invoice amount already processed`, "warning");
                                                                                                    return
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }}
                                                                                    onInputChange={(val) => {
                                                                                        if (val.length > search_length && paymentFor !== null && paymentValue !== null) {
                                                                                            getFinalizeInvoiceListBySearch(val, paymentFor.value, paymentValue.value)
                                                                                        }
                                                                                    }}
                                                                                    onMenuClose={() => {
                                                                                        if (paymentFor == null && paymentFor !== null && paymentValue !== null) {
                                                                                            getFinalizeInvoiceListBySearch("", paymentFor.value, paymentValue.value)
                                                                                        }
                                                                                    }}
                                                                                    isDisabled={paymentFor == null || paymentValue == null}
                                                                                    isLoading={invoiceListApiState}
                                                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                                    placeholder="Choose/Create the invoice"
                                                                                />
                                                                                {obj.invoice_id !== null &&
                                                                                    <a onClick={(e) => { getCustomerInvoiceDetails(obj.invoice_id) }} className="cursor-pointer"><span className="text-primary fs-6">View Invoice</span></a>

                                                                                }
                                                                                {paymentFor == null ?
                                                                                    <span className="text-danger fs-6">Select a payment type first.</span> :
                                                                                    paymentValue == null &&
                                                                                    <span className="text-danger fs-6">Please select a customer name first.</span>
                                                                                }
                                                                            </div>
                                                                            <div className="col-md-4 px-1 mb-2">
                                                                                <label className="fs-5 fw-bold mb-2 required">Account</label>
                                                                                <Select
                                                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                                    options={DepositThroughAccountlist}
                                                                                    onChange={(val) => {
                                                                                        let temp = invoiceArray.map(x => { return { ...x } });
                                                                                        temp[i].deposit_through_account = val.value;
                                                                                        temp[i].deposit_through_account_name = val.label;
                                                                                        temp[i].deposit_through_account_category = DepositThroughAccountlist.find(x => x.options.map(a => a.value).includes(val.value)).id;
                                                                                        setInvoiceArray(temp);

                                                                                    }}
                                                                                    value={{ label: obj.deposit_through_account_name, value: obj.deposit_through_account }}
                                                                                    components={{
                                                                                        MenuList: (props) => {
                                                                                            return (
                                                                                                <components.MenuList  {...props}>
                                                                                                    {props.children}
                                                                                                    <div className='d-flex justify-content-center'>
                                                                                                        <button className='btn btn-success rounded btn-sm my-1' onClick={() => { setSelectedIndex(i); setAddAccHeadModalShow(true) }} >&#10011; Add  Account head</button>
                                                                                                    </div>
                                                                                                </components.MenuList >
                                                                                            )
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-4 px-1 mb-2">
                                                                                <label className="fs-5 fw-bold mb-2">Payment Mode</label>
                                                                                <Select
                                                                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                                    options={PaymentModeList}
                                                                                    onChange={(val) => {
                                                                                        load_configuration_info(val.value, i)
                                                                                    }}
                                                                                    value={{ label: obj.payment_mode, value: obj.payment_mode }}
                                                                                //isClearable
                                                                                />
                                                                                {(obj.invoice_number !== null && obj.payment_amount > 0) &&
                                                                                    <a className="cursor-pointer" onClick={(e) => { setconfigurationIndex(i); setConfigurationModalShow(true); }}>{obj.payment_mode != null && <span className="text-primary fs-6">Configure {obj.payment_mode} Mode</span>}</a>}
                                                                            </div>
                                                                        </div>

                                                                        <div className="row mb-5 gx-0 ">
                                                                            <div className="col-md-3 mb-2">
                                                                                <label className={`fs-5 fw-bold mb-2 ${obj.invoice_new && "required"}`}>Invoice Date</label>
                                                                                <input type="date" className="form-control form-control-solid" value={obj.invoice_date} disabled={!obj.invoice_new} readOnly={!obj.invoice_new}
                                                                                    onChange={(e) => {
                                                                                        let t = invoiceArray.map(x => { return { ...x } })
                                                                                        t[i].invoice_date = e.target.value
                                                                                        setInvoiceArray(t);
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            <div className="col-md-3 px-1 mb-2">
                                                                                <label className={`fs-5 fw-bold mb-2 ${obj.invoice_new && "required"}`}>Invoice Amount</label>
                                                                                <div className="input-group input-group-solid">
                                                                                    <span className="input-group-text">{obj.invoice_currency.currency_symbol}</span>
                                                                                    <input type="number" className="form-control" value={obj.invoice_amount.toString()} disabled={!obj.invoice_new} readOnly={!obj.invoice_new}
                                                                                        onChange={(e) => {
                                                                                            let t = invoiceArray.map(x => { return { ...x } })
                                                                                            t[i].invoice_amount = e.target.value == "" ? 0 : parseFloat(e.target.value);
                                                                                            t[i].payment_amount = e.target.value == "" ? 0 : parseFloat(e.target.value);
                                                                                            setInvoiceArray(t);
                                                                                        }} />
                                                                                </div>
                                                                                {(!obj.invoice_new && obj.invoice_number !== null && obj.invoice_currency.exchange_rate.organization.quote_curr !== obj.invoice_currency.exchange_rate.invoice.quote_curr) &&
                                                                                    <span className="text-primary fs-6">1 {obj.invoice_currency.exchange_rate.organization.quote_curr} = {(Number(obj.invoice_currency.exchange_rate.organization.rate) / Number(obj.invoice_currency.exchange_rate.invoice.rate))} {obj.invoice_currency.exchange_rate.invoice.quote_curr}</span>}
                                                                            </div>
                                                                            {(obj.invoice_new) ?
                                                                                <div className="col-md-3 px-1 mb-2">
                                                                                    <label className="fs-5 fw-bold mb-2 required">Currency</label>
                                                                                    <Select
                                                                                        options={currencyList.map(x => { return { label: x.currency_code, value: x.currency_id, currency_symbol: x.currency_symbol } })}
                                                                                        onChange={(val) => {
                                                                                            let temp = invoiceArray.map(x => { return { ...x } });
                                                                                            temp[i].invoice_currency = val;
                                                                                            setInvoiceArray(temp);
                                                                                        }}
                                                                                        value={obj.invoice_currency}
                                                                                        styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                                    />
                                                                                    {(obj.invoice_currency.label !== baseCurrency.currency_code) &&
                                                                                        <span className="text-primary fs-6">1 {obj.invoice_currency.label} = {trimDecimalPlaces(Number(baseExchangeRate / obj.currency_rate), baseCurrency == null ? 3 : baseCurrency.decimal_place)} {baseCurrency.currency_code}</span>}
                                                                                </div>
                                                                                :
                                                                                <div className="col-md-3 px-1 mb-2">
                                                                                    <label className="fs-5 fw-bold mb-2">Due Amount</label>
                                                                                    <div className="input-group input-group-solid">
                                                                                        <span className="input-group-text">{obj.invoice_currency.currency_symbol}</span>
                                                                                        <input type="number" className="form-control" value={obj.due_amount.toString()} disabled={!obj.invoice_new} readOnly={!obj.invoice_new} />
                                                                                    </div>
                                                                                    {(!obj.invoice_new && obj.invoice_id !== null) && <a className="cursor-pointer" onClick={(e) => { pay_full_amount(obj, i, "individual") }}><span className="text-primary fs-6">Pay full amount</span></a>}
                                                                                </div>
                                                                            }

                                                                            <div className="col-md-3 px-1 mb-2">
                                                                                <label className="fs-5 fw-bold mb-2 required">Payment Amount</label>
                                                                                <div className="input-group input-group-solid">
                                                                                    <span className="input-group-text">{obj.invoice_currency.currency_symbol}</span>
                                                                                    <input type="number" className="form-control" value={obj.payment_amount.toString()}
                                                                                        onChange={(event) => {
                                                                                            let temp = invoiceArray.map(x => { return { ...x } });
                                                                                            let amount = event.target.value == "" ? 0 : parseFloat(event.target.value);
                                                                                            console.log(amount)
                                                                                            if (parseFloat(amount) >= 0) {
                                                                                                let warning_flag = false;
                                                                                                if (obj.invoice_new == false && (obj.invoice_amount - obj.due_amount) !== 0 && amount > (obj.invoice_amount - obj.due_amount)) {
                                                                                                    swal("Oops!", "Amount cannot be greater than Due Amount", "warning");
                                                                                                    temp[i].payment_amount = obj.due_amount;
                                                                                                    warning_flag = true;
                                                                                                }
                                                                                                // if (obj.invoice_new == false && obj.invoice_amount !== 0 && amount > obj.invoice_amount) {
                                                                                                //     swal("Oops!", "Amount cannot be greater than Invoice Amount", "warning");
                                                                                                //     temp[i].payment_amount = obj.due_amount;
                                                                                                //     warning_flag = true;
                                                                                                // }
                                                                                                if (warning_flag == false) {
                                                                                                    temp[i].payment_amount = amount;
                                                                                                }
                                                                                                console.log(temp)
                                                                                                setInvoiceArray(temp);
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            {obj.payment_amount > 0 && trimDecimalPlaces(advancePaymentList.filter(elem => elem.payment_received_currency.currency_code == obj.invoice_currency.currency_code).reduce((p, o) => { return p + Number(o.available_balance) }, 0), baseCurrency == null ? 3 : baseCurrency.decimal_place) > 0 &&
                                                                                <a className="cursor-pointer" onClick={(e) => {
                                                                                    setInvoiceIndexAdjustment(i);
                                                                                    //obj.adjust_amount_arr=advancePaymentList;
                                                                                    if (obj.invoice_new === false) {
                                                                                        setInvoiceIndexCurrency(obj.invoice_currency.currency_code);
                                                                                    }
                                                                                    else {
                                                                                        setInvoiceIndexCurrency(obj.invoice_currency.label);
                                                                                    }
                                                                                    setAdvanceAdjustmentModalShow(true)
                                                                                }}>
                                                                                    {obj.adjust_amount_arr.reduce((p, o) => { return p + (Number(o.adjustable_balance)) }, 0) == 0 &&
                                                                                        <span className={`text-primary fs-6`}>Adjust amount</span>}
                                                                                </a>
                                                                            }
                                                                        </div>
                                                                        {obj.adjust_amount_arr.reduce((p2, o2) => { return p2 + Number(o2.adjustable_balance) }, 0) > 0 &&
                                                                            <div className="row mb-5 gx-0 ">
                                                                                <div className="col-md-3 px-1 mb-2">
                                                                                    <label className="fs-5 fw-bold mb-2 required">Adjustable Amount</label>
                                                                                    <div className="input-group input-group-solid">
                                                                                        <span className="input-group-text">{obj.invoice_currency.currency_symbol}</span>
                                                                                        <input type="number" className="form-control" value={obj.adjust_amount_arr.reduce((p2, o2) => { return p2 + Number(o2.adjustable_balance) }, 0)} disabled={true} readOnly={true} />
                                                                                    </div>
                                                                                    <a className="cursor-pointer" onClick={() => {
                                                                                        setInvoiceIndexAdjustment(i);
                                                                                        //obj.adjust_amount_arr=advancePaymentList;
                                                                                        if (obj.invoice_new === false) {
                                                                                            setInvoiceIndexCurrency(obj.invoice_currency.currency_code);
                                                                                        }
                                                                                        else {
                                                                                            setInvoiceIndexCurrency(obj.invoice_currency.label);
                                                                                        }
                                                                                        setAdvanceAdjustmentModalShow(true)
                                                                                    }}>
                                                                                        <span className={`text-success fs-6`}>Edit Adjust amount</span></a>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                        <button className='btn btn-primary btn-sm m-3' onClick={() => { setInvoiceArray([...invoiceArray, { invoice_number: null, invoice_id: null, invoice_date: "", invoice_new: false, billing_address: null, shipping_address: null, gstin_details: null, invoice_amount: 0, invoice_currency: baseCurrency, due_amount: 0, payment_amount: 0, deposit_through_account: default_acc.value, deposit_through_account_category: default_acc.category, deposit_through_account_name: default_acc.label, payment_mode: "Cash", adjust_amount_arr: [], configuration_obj: { denomination: [], notes: "" } }]) }}>+ Add Invoice</button>
                                                    </div>
                                                </>
                                            }

                                            {(PaymentAmount > 0 || Calculation_info.payment_amount > 0) &&
                                                <div className="d-flex flex-stack bg-success rounded-3 p-6 mb-11">
                                                    <div className="fs-6 fw-bold text-white">
                                                        {Payment_Type == "Invoice Payment" ?
                                                            <>
                                                                {(Calculation_info.total_amount > 0 && Calculation_info.adjustable_amount > 0) &&
                                                                    <span className="d-block mb-2">Total Amount</span>}
                                                                {Calculation_info.adjustable_amount > 0 &&
                                                                    <span className="d-block lh-1 mb-2">Adjustable Amount</span>
                                                                }
                                                                {Calculation_info.payment_amount > 0 &&
                                                                    <span className="d-block lh-1 mb-2">Payment Amount</span>
                                                                }
                                                            </>
                                                            :
                                                            <span className="d-block lh-1 mb-2">Payment Amount</span>
                                                        }
                                                    </div>
                                                    <div className="fs-6 fw-bold text-white text-end">
                                                        {Payment_Type == "Invoice Payment" ?
                                                            <>
                                                                {(Calculation_info.total_amount > 0 && Calculation_info.adjustable_amount > 0) &&
                                                                    <span className="d-block mb-2">{baseCurrency.currency_symbol}&nbsp;{formatNumber(Calculation_info.total_amount, { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}</span>}
                                                                {Calculation_info.adjustable_amount > 0 &&
                                                                    <span className="d-block lh-1 mb-2">{baseCurrency.currency_symbol}&nbsp;{formatNumber(Calculation_info.adjustable_amount, { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}</span>}
                                                                {Calculation_info.payment_amount > 0 &&
                                                                    <span className="d-block lh-1 mb-2">{baseCurrency.currency_symbol}&nbsp;{formatNumber(Calculation_info.payment_amount, { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}</span>}
                                                            </>
                                                            :
                                                            <>
                                                                {PaymentAmount > 0 &&
                                                                    <span className="d-block lh-1 mb-2">{currencyList.find(x => x.currency_id == selectedCurrency.value).currency_symbol}&nbsp;{formatNumber(PaymentAmount, { ...formatNumberOptions, currencyFormat: selectedCurrency.format, decimalPlaces: selectedCurrency.decimal_place })}</span>}
                                                            </>
                                                        }

                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <hr />
                                        <br />
                                        <div className="row mb-5">
                                            <div className="col-md-6 my-2">
                                                <label className="fs-5 fw-bold mb-2">Notes</label>
                                                <textarea className="form-control form-control-solid" value={Notes} onChange={(e) => { setNotes(e.target.value) }} placeholder={""}></textarea>
                                            </div>
                                            <div className="col-md-6 fv-row">
                                                <label className="fs-5 fw-bold mb-2">Reference</label>
                                                <textarea type="text" className="form-control form-control-solid" placeholder="" name="subcategory-name" onChange={(e) => { setReferences(e.target.value) }} />
                                            </div>
                                        </div>
                                        {
                                            write && (paymentReceivedDetails != null && paymentReceivedDetails.add_status == "PAYMENT_DRAFT") &&
                                            <button type="button" className="btn btn-lg btn-primary mt-15 mx-3 rounded" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} onClick={() => { validatePayment() && newPaymentSubmit(false) }}>
                                                <span className="indicator-label">Save as Draft</span>
                                                <span className="indicator-progress">Please wait...
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                            </button>
                                        }

                                        <button type="button" className="btn btn-lg btn-info mt-15 mx-3 rounded" data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState} onClick={() => { validatePayment() && newPaymentSubmit(true) }}>
                                            {(approvalInfo !== null && approvalInfo.type == "not_configure") ? <span className="indicator-label">Save & Approve (Paid)</span> : <span className="indicator-label">Save</span>}
                                            <span className="indicator-progress">Please wait...
                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </span>
                                        </button>
                                    </>
                                    :
                                    <>
                                        {
                                            state == 2 ?
                                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                                :
                                                <PageError message={failedPageMessage}>
                                                    <Link to={`/payment-received-list`} className="btn btn-sm btn-primary me-3 rounded cursor-pointer">Go to Received Payment List</Link>
                                                </PageError>
                                        }
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={addAccHeadModalShow} onHide={() => { setAddAccHeadModalShow(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>New Head</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setAddAccHeadModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Account Category</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <Select
                                    className="form-control form-control-solid"
                                    styles={theme === 'dark' ? dropdownStyleDark : {}}
                                    options={categoryList.map(x => { return { label: x.category_name, value: x.cid, headArray: x.headArray } })}
                                    onChange={(val) => {
                                        setAccountHeadList(val.headArray);
                                        setNewHead({ ...newHead, uq_ac: val.value, parent: "" })
                                    }}
                                    placeholder="Select Category"
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Name</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    onChange={(e) => { setNewHead({ ...newHead, name: e.target.value }) }}
                                    placeholder='Name of Head'
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Code</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="text" className="form-control form-control-solid"
                                    onChange={(e) => { setNewHead({ ...newHead, code: e.target.value }) }}
                                    placeholder='Codename of Head'
                                />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="required fs-5 mb-2">Sub</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <input type="checkbox" className=""
                                    onChange={(e) => { setNewHead({ ...newHead, sub: e.target.checked ? 1 : 0 }) }}
                                />
                            </div>
                        </div>
                        {
                            newHead.sub ?
                                <>
                                    <div className="d-flex justify-content-between mb-5">
                                        <div className="col-3 my-auto">
                                            <label className="required fs-5 mb-2">Parent Head</label>
                                        </div>
                                        <div className='col-9 my-auto'>
                                            <Select
                                                className="form-control form-control-solid"
                                                styles={theme === 'dark' ? dropdownStyleDark : {}}
                                                options={accountheadList.map(x => { return { label: x.name, value: x.hid } })}
                                                onChange={(val) => {
                                                    setNewHead({ ...newHead, parent: val.value })
                                                }}
                                                placeholder="Select Parent Head"
                                            />
                                        </div>
                                    </div>
                                </>
                                : null}
                        <div className="d-flex justify-content-between mb-5">
                            <div className="col-3 my-auto">
                                <label className="fs-5 mb-2">Description</label>
                            </div>
                            <div className='col-9 my-auto'>
                                <textarea type="text" className="form-control form-control-solid"
                                    // value={primaryContact.firstName}
                                    onChange={(e) => { setNewHead({ ...newHead, description: e.target.value }) }}
                                    placeholder='Description for account head'
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded me-auto" onClick={() => { setAddAccHeadModalShow(false) }}>Close</button>
                    {
                        // write  &&
                        <button className="btn btn-success rounded" data-kt-indicator={submitButton ? "on" : "off"} disabled={submitButton} onClick={() => { newHeadSubmit() }}>
                            <span className="indicator-label">Save and Continue</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>

            <Modal show={advanceAdjustmentModalShow} onHide={() => { setAdvanceAdjustmentModalShow(false) }} centered>
                <Modal.Header>
                    <Modal.Title>Adjust Advance Amount</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setAdvanceAdjustmentModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="d-flex flex-column gap-3">
                            {(Payment_Type == "Invoice Payment" && invoiceIndexAdjustment !== null && advancePaymentList.length > 0 && invoiceArray.length > 0) &&
                                advancePaymentList.map((obj3, i) => {
                                    if (obj3.payment_received_currency.currency_code == invoiceArray[invoiceIndexAdjustment].invoice_currency.currency_code) {
                                        let current_available_balance = obj3.available_balance - trimDecimalPlaces(invoiceArray.filter(elem => elem.invoice_currency.currency_code == invoiceArray[invoiceIndexAdjustment].invoice_currency.currency_code).reduce((acc, curr) => acc + curr.adjust_amount_arr.reduce((pAcc, pCurr) => {
                                            if (pCurr.ref == obj3.Payment_id) {
                                                return pAcc + pCurr.adjustable_balance;
                                            }
                                            else {
                                                return pAcc;
                                            }
                                        }, 0), 0), baseCurrency == null ? 3 : baseCurrency.decimal_place);
                                        return (
                                            <div className="row mb-5">
                                                <div className="col-md-6">
                                                    <div className="d-flex align-items-center mb-6 me-4">
                                                        <span data-kt-element="bullet" className="bullet bullet-vertical d-flex align-items-center min-h-70px mh-100 me-4 bg-info"></span>
                                                        <div className="flex-grow-1 me-5">
                                                            <div className="text-gray-800 fw-semibold fs-2">
                                                                {obj3.Payment_id}
                                                            </div>
                                                            <div className="text-gray-400 fw-semibold fs-7 me-1">
                                                                Available Balance: <span className="text-primary opacity-75-hover fw-semibold">{obj3.payment_received_currency.currency_symbol} {current_available_balance}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="input-group input-group-solid">
                                                        <span className="input-group-text">{obj3.payment_received_currency.currency_symbol}</span>
                                                        <input type="number" className="form-control" value={invoiceArray[invoiceIndexAdjustment].adjust_amount_arr.find(x => x.ref === obj3.Payment_id) !== undefined ? invoiceArray[invoiceIndexAdjustment].adjust_amount_arr.find(x => x.ref === obj3.Payment_id).adjustable_balance.toString() : 0} min="0"
                                                            onChange={(e) => {
                                                                let amount = e.target.value == "" ? 0 : parseFloat(e.target.value);
                                                                const current_amount = invoiceArray[invoiceIndexAdjustment].adjust_amount_arr.find(x => x.ref === obj3.Payment_id) !== undefined ? invoiceArray[invoiceIndexAdjustment].adjust_amount_arr.find(x => x.ref === obj3.Payment_id).adjustable_balance.toString() : 0
                                                                if (amount > (current_available_balance + Number(current_amount))) {
                                                                    swal("Oops!", "Amount cannot be greater than available balance", "warning");
                                                                }
                                                                else if (amount > invoiceArray[invoiceIndexAdjustment].payment_amount) {
                                                                    swal("Oops!", "Amount cannot be greater than payment amount", "warning");
                                                                }
                                                                else if (amount > 0) {
                                                                    let t = invoiceArray.map(x => { return { ...x } })
                                                                    let temp = t[invoiceIndexAdjustment].adjust_amount_arr.find(x => x.ref === obj3.Payment_id)
                                                                    if (temp !== undefined) {
                                                                        temp.adjustable_balance = amount;
                                                                    }
                                                                    else {
                                                                        t[invoiceIndexAdjustment].adjust_amount_arr.push({ ref: obj3.Payment_id, adjustable_balance: amount })
                                                                    }
                                                                    setInvoiceArray(t);
                                                                    let t1 = advancePaymentList.map(x => { return { ...x } });
                                                                    t1[i].adjustable_balance = trimDecimalPlaces(invoiceArray[invoiceIndexAdjustment].adjust_amount_arr.reduce((p, o) => { return p + Number(o.adjustable_balance) }, 0), baseCurrency == null ? 3 : baseCurrency.decimal_place);
                                                                    setAdvancePaymentList(t1);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <span className="text-gray fs-6">Adjustable amount</span>
                                                </div>
                                            </div>
                                        )
                                    }
                                })}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary rounded me-auto" onClick={() => { resetAdvanceAdjustment(); }}>Reset</button>
                    <button className="btn btn-success rounded" onClick={() => { setAdvanceAdjustmentModalShow(false) }}>Save</button>
                </Modal.Footer>
            </Modal>

            <Modal show={addressModalShow} onHide={() => { handleAddressModalClose(); }} centered>
                <Modal.Header>
                    <Modal.Title>Select an Address</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleAddressModalClose(); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="d-flex flex-column gap-3">
                            {
                                addressListApiState ? <div className='d-flex justify-content-center'><div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} ></div></div> :
                                    addressList.length == 0 ? <div className='fs-2 text-gray-600'>No Data Available</div> :
                                        addressList.length > 0 &&
                                        addressList.map((obj, indx) => {
                                            return (
                                                <>
                                                    <div key={indx} className="card card-dashed flex-wrap p-6" style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            if (Payment_Type == "Invoice Payment") {
                                                                let t = invoiceArray.map(x => { return { ...x } })
                                                                if (addressType == "billing") {
                                                                    t[invoiceIndexAddress].billing_address = obj
                                                                }
                                                                else {
                                                                    t[invoiceIndexAddress].shipping_address = obj
                                                                }
                                                                setInvoiceArray(t);
                                                            }
                                                            else {
                                                                if (addressType == "billing") {
                                                                    setSelectedBillingAddress(obj);
                                                                }
                                                                else {
                                                                    setSelectedShippingAddress(obj);
                                                                }

                                                            }

                                                            handleAddressModalClose()
                                                        }}
                                                    >
                                                        <div className="d-flex flex-column py-2">
                                                            <div className="fs-6 fw-semibold text-gray-600">
                                                                {obj.state}
                                                                <br />{obj.city},{obj.pincode}
                                                                <br />{obj.country}
                                                            </div>
                                                        </div>
                                                        {
                                                            (addressId === obj.id) &&
                                                            <div className='position-absolute' style={{ top: "1rem", right: "1rem" }} >
                                                                <svg width="30" height="30" viewBox="0 0 64 64">
                                                                    <path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50  l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047" />
                                                                </svg>
                                                            </div>
                                                        }
                                                    </div>
                                                </>
                                            );
                                        })
                            }
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary rounded" onClick={() => { handleAddressModalClose() }}>Save</button>
                </Modal.Footer>
            </Modal>
            <Modal show={advanceConfigurationModalShow} onHide={() => { setAdvanceConfigurationModalShow(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Configure {PaymentMode.label} Mode</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setAdvanceConfigurationModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>

                    <div className='container' style={{ overflowY: "scroll", height: "21rem" }}>
                        {(PaymentMode.label == "Cash" && selectedCurrency !== null) ?
                            <>
                                <div className="table-responsive mb-8">
                                    <table className="table align-end gs-0 gy-4 my-0">
                                        <thead>
                                            <tr>
                                                <th className="min-w-100px">Amount</th>
                                                <th className="min-w-75px align-items-center text-center">Count</th>
                                                <th className="text-end min-w-75px">Total Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                amtArray.map((obj3, indx3) => {
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td className="py-0">
                                                                    <div className="" style={{ verticalAlign: "middle", lineHeight: "40px" }}>
                                                                        <span className="fw-bold text-gray-800 cursor-pointer text-hover-primary fs-6 me-1">{selectedCurrency.currency_symbol} {obj3.category}</span>
                                                                    </div>
                                                                </td>
                                                                <td className="py-0">
                                                                    <div className="position-relative d-flex align-items-center justify-content-center" data-kt-dialer="true" data-kt-dialer-min="1" data-kt-dialer-max="10" data-kt-dialer-step="1" data-kt-dialer-decimals="0">
                                                                        <button type="button" className="btn btn-icon btn-sm btn-light btn-icon-gray-400"
                                                                            onClick={() => {
                                                                                let temp = amtArray.map(a => { return { ...a } })
                                                                                if (obj3.count > 0) {
                                                                                    temp[indx3].count = parseInt(obj3.count) - 1;
                                                                                    temp[indx3].amount = temp[indx3].count * parseInt(obj3.category);
                                                                                }
                                                                                setamtArray(temp);

                                                                                setConfiguration_obj({ ...Configuration_obj, denomination: temp });
                                                                            }}>
                                                                            <span className="svg-icon svg-icon-3x"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"></rect>
                                                                            </svg>
                                                                            </span>
                                                                        </button>
                                                                        <input type="text" className="form-control border-0 text-center px-0 fs-3 fw-bold text-gray-800 w-30px" placeholder="Amount" name="manageBudget" readonly="" min="0" value={obj3.count} />
                                                                        <button type="button" className="btn btn-icon btn-sm btn-light btn-icon-gray-400"
                                                                            onClick={() => {
                                                                                let temp = amtArray.map(a => { return { ...a } });
                                                                                temp[indx3].count = parseInt(obj3.count) + 1;
                                                                                temp[indx3].amount = temp[indx3].count * parseInt(obj3.category);
                                                                                if (checkDenominationValidation(temp, PaymentAmount)) {
                                                                                    setamtArray(temp);
                                                                                    setConfiguration_obj({ ...Configuration_obj, denomination: temp });
                                                                                }
                                                                            }}>
                                                                            <span className="svg-icon svg-icon-3x"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor"></rect>
                                                                                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"></rect>
                                                                            </svg></span>
                                                                        </button>
                                                                    </div>
                                                                </td>

                                                                <td className="text-end py-0">
                                                                    <div style={{ verticalAlign: "middle", lineHeight: "40px" }}>
                                                                        <span className="fw-bold text-primary fs-4">{selectedCurrency.currency_symbol} {obj3.amount}</span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table><hr />
                                    <div className="row">
                                        <div className="col-3">
                                            <span className="fw-bold text-primary fs-3">Subtotal</span>
                                        </div>
                                        <div className="col-3"></div>
                                        <div className="col-3">
                                        </div>
                                        <div className="col-3 text-end">
                                            <span className="fw-bold text-primary fs-3">{selectedCurrency.currency_symbol} {trimDecimalPlaces(amtArray.reduce((p, o) => { return p + (o.count * parseInt(o.category)) }, 0), 3)}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-5">
                                    <div className="col-md-12 my-2">
                                        <label className="fs-5 fw-bold mb-2">Notes</label>
                                        <textarea className="form-control form-control-solid" rows="3" value={Configuration_obj.notes}
                                            onChange={(e) => {
                                                setConfiguration_obj({ ...Configuration_obj, notes: e.target.value })
                                            }}
                                            placeholder={""}>
                                        </textarea>
                                    </div>
                                </div>
                            </>
                            :
                            PaymentMode.label == "Cheque" ?
                                <>
                                    <div className="row mb-5">
                                        <div className="col-md-10">
                                            <label className="fs-5 fw-bold mb-2">Bank Name</label>
                                            <input type="text" className="form-control form-control-solid" value={Configuration_obj.bank_name}
                                                onChange={(e) => {
                                                    setConfiguration_obj({ ...Configuration_obj, bank_name: e.target.value })
                                                }} />
                                        </div>
                                    </div>
                                    <div className="row mb-5">
                                        <div className="col-md-5">
                                            <label className="required fs-5 fw-bold mb-2">Cheque Number</label>
                                            <input type="text" className="form-control form-control-solid" value={Configuration_obj.cheque_no}
                                                onChange={(e) => {
                                                    setConfiguration_obj({ ...Configuration_obj, cheque_no: e.target.value })
                                                }} />
                                        </div>
                                        <div className="col-md-5">
                                            <label className="required fs-5 fw-bold mb-2">Cheque Date</label>
                                            <input type="date" className="form-control form-control-solid" max={new Date().toISOString().split('T')[0]} value={Configuration_obj.cheque_date}
                                                onChange={(e) => {
                                                    setConfiguration_obj({ ...Configuration_obj, cheque_date: e.target.value })
                                                }} />
                                        </div>
                                    </div>
                                    <div className="row mb-5">
                                        <div className="col-md-12 my-2">
                                            <label className="fs-5 fw-bold mb-2">Notes</label>
                                            <textarea className="form-control form-control-solid" rows="3" value={Configuration_obj.notes}
                                                onChange={(e) => {
                                                    setConfiguration_obj({ ...Configuration_obj, notes: e.target.value })
                                                }}
                                                placeholder={""}>
                                            </textarea>
                                        </div>
                                    </div>
                                </>
                                :
                                PaymentMode.label == "Bank Transfer" ?
                                    <>
                                        <div className="row mb-5">
                                            <div className="col-md-10">
                                                <label className="fs-5 fw-bold mb-2">Bank Name</label>
                                                <input type="text" className="form-control form-control-solid" value={Configuration_obj.bank_name}
                                                    onChange={(e) => {
                                                        setConfiguration_obj({ ...Configuration_obj, bank_name: e.target.value })
                                                    }} />
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-5">
                                                <label className="required fs-5 fw-bold mb-2">Transaction ID</label>
                                                <input type="text" className="form-control form-control-solid" value={Configuration_obj.transaction_id}
                                                    onChange={(e) => {
                                                        setConfiguration_obj({ ...Configuration_obj, transaction_id: e.target.value })
                                                    }} />
                                            </div>
                                            <div className="col-md-5">
                                                <label className="required fs-5 fw-bold mb-2">Date</label>
                                                <input type="date" className="form-control form-control-solid" max={new Date().toISOString().split('T')[0]} value={Configuration_obj.date}
                                                    onChange={(e) => {
                                                        setConfiguration_obj({ ...Configuration_obj, date: e.target.value })
                                                    }} />
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-12 my-2">
                                                <label className="fs-5 fw-bold mb-2">Notes</label>
                                                <textarea className="form-control form-control-solid" rows="3" value={Configuration_obj.notes}
                                                    onChange={(e) => {
                                                        setConfiguration_obj({ ...Configuration_obj, notes: e.target.value })
                                                    }}
                                                    placeholder={""}>
                                                </textarea>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    PaymentMode.label == "Credit Card" ?
                                        <>
                                            <div className="row mb-5">
                                                <div className="col-md-5">
                                                    <label className="required fs-5 fw-bold mb-2">Reference Number</label>
                                                    <input type="text" className="form-control form-control-solid" value={Configuration_obj.ref_number}
                                                        onChange={(e) => {
                                                            setConfiguration_obj({ ...Configuration_obj, ref_number: e.target.value })
                                                        }} />
                                                </div>

                                                <div className="col-md-5">
                                                    <label className="fs-5 fw-bold mb-2">CVV</label>
                                                    <input type="text" className="form-control form-control-solid" value={Configuration_obj.cvv}
                                                        onChange={(e) => {
                                                            setConfiguration_obj({ ...Configuration_obj, cvv: e.target.value })
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="row mb-5">
                                                <div className="col-md-10">
                                                    <label className="fs-5 fw-bold mb-2">Card Type</label>
                                                    <Select
                                                        styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                        name="category"
                                                        id="category"
                                                        options={debitcardlist}
                                                        onChange={(val) => {
                                                            setConfiguration_obj({ ...Configuration_obj, card_type: val.value })
                                                        }}
                                                        value={{ label: Configuration_obj.card_type, value: Configuration_obj.card_type }}
                                                        placeholder="--Choose a Type--"
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-5">
                                                <div className="col-md-12 my-2">
                                                    <label className="fs-5 fw-bold mb-2">Notes</label>
                                                    <textarea className="form-control form-control-solid" rows="3" value={Configuration_obj.notes}
                                                        onChange={(e) => {
                                                            setConfiguration_obj({ ...Configuration_obj, notes: e.target.value })
                                                        }}
                                                        placeholder={""}>
                                                    </textarea>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        PaymentMode.label == "Debit Card" ?
                                            <>
                                                <div className="row mb-5">
                                                    <div className="col-md-5">
                                                        <label className="required fs-5 fw-bold mb-2">Reference Number</label>
                                                        <input type="text" className="form-control form-control-solid" value={Configuration_obj.ref_number}
                                                            onChange={(e) => {
                                                                setConfiguration_obj({ ...Configuration_obj, ref_number: e.target.value })
                                                            }} />
                                                    </div>

                                                    <div className="col-md-5">
                                                        <label className="fs-5 fw-bold mb-2">CVV</label>
                                                        <input type="text" className="form-control form-control-solid" value={Configuration_obj.cvv}
                                                            onChange={(e) => {
                                                                setConfiguration_obj({ ...Configuration_obj, cvv: e.target.value })
                                                            }} />
                                                    </div>
                                                </div>
                                                <div className="row mb-5">
                                                    <div className="col-md-10">
                                                        <label className="fs-5 fw-bold mb-2">Card Type</label>
                                                        <Select
                                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                            name="category"
                                                            id="category"
                                                            options={debitcardlist}
                                                            onChange={(val) => {
                                                                setConfiguration_obj({ ...Configuration_obj, card_type: val.value })
                                                            }}
                                                            value={{ label: Configuration_obj.card_type, value: Configuration_obj.card_type }}
                                                            placeholder="--Choose a Type--"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mb-5">
                                                    <div className="col-md-12 my-2">
                                                        <label className="fs-5 fw-bold mb-2">Notes</label>
                                                        <textarea className="form-control form-control-solid" rows="3" value={Configuration_obj.notes}
                                                            onChange={(e) => {
                                                                setConfiguration_obj({ ...Configuration_obj, notes: e.target.value })
                                                            }}
                                                            placeholder={""}>
                                                        </textarea>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            PaymentMode.label == "UPI" &&
                                            <>
                                                <div className="col-md-5">
                                                    <label className="required fs-5 fw-bold mb-2">Transaction Ref. ID</label>
                                                    <input type="text" className="form-control form-control-solid" value={Configuration_obj.transaction_id}
                                                        onChange={(e) => {
                                                            setConfiguration_obj({ ...Configuration_obj, transaction_id: e.target.value })
                                                        }} />
                                                </div>
                                                <div className="row mb-5">
                                                    <div className="col-md-12 my-2">
                                                        <label className="fs-5 fw-bold mb-2">Notes</label>
                                                        <textarea className="form-control form-control-solid" rows="3" value={Configuration_obj.notes}
                                                            onChange={(e) => {
                                                                setConfiguration_obj({ ...Configuration_obj, notes: e.target.value })
                                                            }}
                                                            placeholder={""}>
                                                        </textarea>
                                                    </div>
                                                </div>
                                            </>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary rounded me-auto" onClick={() => { Config_set_up(PaymentMode.value); }}>Reset</button>
                    <button className="btn btn-success rounded" onClick={() => { setAdvanceConfigurationModalShow(false); }}>Save</button>
                </Modal.Footer>
            </Modal>
            <Modal show={ConfigurationModalShow} onHide={() => { setConfigurationModalShow(false) }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>{invoiceArray.length > 0 && <>Configure {invoiceArray[configurationindex].payment_mode} Mode</>}</Modal.Title>
                    <div>
                        <button onClick={(e) => { setCopyMode(invoiceArray[configurationindex].payment_mode); setCopyIndex(configurationindex); setCopyData(invoiceArray[configurationindex].configuration_obj) }} className={(copyData !== null && copyMode == invoiceArray[configurationindex].payment_mode && configurationindex == copyIndex) ? `btn btn-success btn-icon btn-sm btn-outline-light mx-2` : `btn btn-primary btn-icon btn-sm btn-outline-light mx-2`}>
                            <span className="svg-icon svg-icon-2">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.5" d="M18 2H9C7.34315 2 6 3.34315 6 5H8C8 4.44772 8.44772 4 9 4H18C18.5523 4 19 4.44772 19 5V16C19 16.5523 18.5523 17 18 17V19C19.6569 19 21 17.6569 21 16V5C21 3.34315 19.6569 2 18 2Z" fill="currentColor"></path>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M14.7857 7.125H6.21429C5.62255 7.125 5.14286 7.6007 5.14286 8.1875V18.8125C5.14286 19.3993 5.62255 19.875 6.21429 19.875H14.7857C15.3774 19.875 15.8571 19.3993 15.8571 18.8125V8.1875C15.8571 7.6007 15.3774 7.125 14.7857 7.125ZM6.21429 5C4.43908 5 3 6.42709 3 8.1875V18.8125C3 20.5729 4.43909 22 6.21429 22H14.7857C16.5609 22 18 20.5729 18 18.8125V8.1875C18 6.42709 16.5609 5 14.7857 5H6.21429Z" fill="currentColor"></path>
                                </svg>
                            </span>
                        </button>
                        {(copyData !== null && copyMode == invoiceArray[configurationindex].payment_mode && configurationindex !== copyIndex) &&
                            <button onClick={(e) => {
                                let temp_invoice = invoiceArray.map(a => { return { ...a } });
                                temp_invoice[configurationindex].configuration_obj = copyData;
                                setInvoiceArray(temp_invoice);
                            }} className={`btn btn-primary btn-icon btn-sm btn-outline-light mx-2`}>
                                <span className="svg-icon svg-icon-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <path d="M3 21h5v-1H4V4h2v2h10V4h2v3h.4a.989.989 0 0 1 .6.221V3h-3V2h-3a2 2 0 0 0-4 0H6v1H3zM7 3h3V1.615A.615.615 0 0 1 10.614 1h.771a.615.615 0 0 1 .615.615V3h3v2H7zm4 14h9v1h-9zM9 8v16h13V11.6L18.4 8zm12 15H10V9h7v4h4zm0-11h-3V9h.31L21 11.69zm-10 2h9v1h-9zm0 6h7v1h-7z" /><path fill="none" d="M0 0h24v24H0z" /></svg>
                                </span>
                            </button>}
                        <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setConfigurationModalShow(false) }}>
                            <span className="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                        <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                        <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                    </g>
                                </svg>
                            </span>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {invoiceArray.length > 0 &&
                        <div className='container' style={{ overflowY: "scroll", height: "21rem" }}>
                            {invoiceArray[configurationindex].payment_mode == "Cash" ?
                                <>
                                    <div className="table-responsive mb-8">
                                        <table className="table align-end gs-0 gy-4 my-0">
                                            <thead>
                                                <tr>
                                                    <th className="min-w-100px">Amount</th>
                                                    <th className="min-w-75px align-items-center text-center">Count</th>
                                                    <th className="text-end min-w-75px">Total Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    amtArray.map((obj3, indx3) => {
                                                        return (
                                                            <>
                                                                <tr>
                                                                    <td className="py-0">
                                                                        <div className="" style={{ verticalAlign: "middle", lineHeight: "40px" }}>
                                                                            <span className="fw-bold text-gray-800 cursor-pointer text-hover-primary fs-6 me-1">{invoiceArray[configurationindex].invoice_currency.currency_symbol} {obj3.category}</span>
                                                                        </div>
                                                                    </td>
                                                                    <td className="py-0">
                                                                        <div className="position-relative d-flex align-items-center justify-content-center" data-kt-dialer="true" data-kt-dialer-min="1" data-kt-dialer-max="10" data-kt-dialer-step="1" data-kt-dialer-decimals="0">
                                                                            <button type="button" className="btn btn-icon btn-sm btn-light btn-icon-gray-400"
                                                                                onClick={() => {
                                                                                    let temp = amtArray.map(a => { return { ...a } })
                                                                                    if (obj3.count > 0) {
                                                                                        temp[indx3].count = parseInt(obj3.count) - 1;
                                                                                        temp[indx3].amount = temp[indx3].count * parseInt(obj3.category);
                                                                                    }
                                                                                    setamtArray(temp)

                                                                                    let temp_invoice = invoiceArray.map(a => { return { ...a } });
                                                                                    temp_invoice[configurationindex].configuration_obj.denomination = temp;
                                                                                    setInvoiceArray(temp_invoice);
                                                                                }}>
                                                                                <span className="svg-icon svg-icon-3x"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"></rect>
                                                                                </svg>
                                                                                </span>
                                                                            </button>
                                                                            <input type="text" className="form-control border-0 text-center px-0 fs-3 fw-bold text-gray-800 w-30px" placeholder="Amount" name="manageBudget" readonly="" min="0" value={obj3.count} />
                                                                            <button type="button" className="btn btn-icon btn-sm btn-light btn-icon-gray-400"
                                                                                onClick={() => {
                                                                                    let temp = amtArray.map(a => { return { ...a } });
                                                                                    let temp_invoice = invoiceArray.map(a => { return { ...a } });
                                                                                    temp[indx3].count = parseInt(obj3.count) + 1;
                                                                                    temp[indx3].amount = temp[indx3].count * parseInt(obj3.category);
                                                                                    if (checkDenominationValidation(temp, temp_invoice[configurationindex].payment_amount)) {
                                                                                        setamtArray(temp);
                                                                                        temp_invoice[configurationindex].configuration_obj.denomination = temp;
                                                                                        setInvoiceArray(temp_invoice);
                                                                                    }
                                                                                }}>
                                                                                <span className="svg-icon svg-icon-3x"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor"></rect>
                                                                                    <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"></rect>
                                                                                </svg></span>
                                                                            </button>
                                                                        </div>

                                                                    </td>

                                                                    <td className="text-end py-0">
                                                                        <div style={{ verticalAlign: "middle", lineHeight: "40px" }}>
                                                                            <span className="fw-bold text-primary fs-4">{invoiceArray[configurationindex].invoice_currency.currency_symbol} {obj3.amount}</span>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table><hr />
                                        <div className="row">
                                            <div className="col-3">
                                                <span className="fw-bold text-primary fs-3">Subtotal</span>
                                            </div>
                                            <div className="col-3"></div>
                                            <div className="col-3">
                                            </div>
                                            <div className="col-3 text-end">
                                                <span className="fw-bold text-primary fs-3">{invoiceArray[configurationindex].invoice_currency.currency_symbol} {trimDecimalPlaces(amtArray.reduce((p, o) => { return p + (o.count * parseInt(o.category)) }, 0), 3)}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-5">
                                        <div className="col-md-12 my-2">
                                            <label className="fs-5 fw-bold mb-2">Notes</label>
                                            <textarea className="form-control form-control-solid" rows="3" value={invoiceArray[configurationindex].configuration_obj.notes}
                                                onChange={(e) => {
                                                    let temp = invoiceArray.map(a => { return { ...a } })
                                                    temp[configurationindex].configuration_obj.notes = e.target.value
                                                    setInvoiceArray(temp)
                                                }}
                                                placeholder={""}>
                                            </textarea>
                                        </div>
                                    </div>
                                </>
                                :
                                invoiceArray[configurationindex].payment_mode == "Cheque" ?
                                    <>
                                        <div className="row mb-5">
                                            <div className="col-md-10">
                                                <label className="fs-5 fw-bold mb-2">Bank Name</label>
                                                <input type="text" className="form-control form-control-solid" value={invoiceArray[configurationindex].configuration_obj.bank_name}
                                                    onChange={(e) => {
                                                        let temp = invoiceArray.map(a => { return { ...a } })
                                                        temp[configurationindex].configuration_obj.bank_name = e.target.value
                                                        setInvoiceArray(temp)
                                                    }} />
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-5">
                                                <label className="required fs-5 fw-bold mb-2">Cheque Number</label>
                                                <input type="text" className="form-control form-control-solid" value={invoiceArray[configurationindex].configuration_obj.cheque_no}
                                                    onChange={(e) => {
                                                        let temp = invoiceArray.map(a => { return { ...a } })
                                                        temp[configurationindex].configuration_obj.cheque_no = e.target.value
                                                        setInvoiceArray(temp)
                                                    }} />
                                            </div>
                                            <div className="col-md-5">
                                                <label className="required fs-5 fw-bold mb-2">Cheque Date</label>
                                                <input type="date" className="form-control form-control-solid" max={new Date().toISOString().split('T')[0]} value={invoiceArray[configurationindex].configuration_obj.cheque_date}
                                                    onChange={(e) => {
                                                        let temp = invoiceArray.map(a => { return { ...a } })
                                                        temp[configurationindex].configuration_obj.cheque_date = e.target.value
                                                        setInvoiceArray(temp)
                                                    }} />
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-12 my-2">
                                                <label className="fs-5 fw-bold mb-2">Notes</label>
                                                <textarea className="form-control form-control-solid" rows="3" value={invoiceArray[configurationindex].configuration_obj.notes}
                                                    onChange={(e) => {
                                                        let temp = invoiceArray.map(a => { return { ...a } })
                                                        temp[configurationindex].configuration_obj.notes = e.target.value
                                                        setInvoiceArray(temp)
                                                    }}
                                                    placeholder={""}>
                                                </textarea>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    invoiceArray[configurationindex].payment_mode == "Bank Transfer" ?
                                        <>
                                            <div className="row mb-5">
                                                <div className="col-md-10">
                                                    <label className="fs-5 fw-bold mb-2">Bank Name</label>
                                                    <input type="text" className="form-control form-control-solid" value={invoiceArray[configurationindex].configuration_obj.bank_name}
                                                        onChange={(e) => {
                                                            let temp = invoiceArray.map(a => { return { ...a } })
                                                            temp[configurationindex].configuration_obj.bank_name = e.target.value
                                                            setInvoiceArray(temp)
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="row mb-5">
                                                <div className="col-md-5">
                                                    <label className="required fs-5 fw-bold mb-2">Transaction ID</label>
                                                    <input type="text" className="form-control form-control-solid" value={invoiceArray[configurationindex].configuration_obj.transaction_id}
                                                        onChange={(e) => {
                                                            let temp = invoiceArray.map(a => { return { ...a } })
                                                            temp[configurationindex].configuration_obj.transaction_id = e.target.value
                                                            setInvoiceArray(temp)
                                                        }} />
                                                </div>
                                                <div className="col-md-5">
                                                    <label className="required fs-5 fw-bold mb-2">Date</label>
                                                    <input type="date" className="form-control form-control-solid" max={new Date().toISOString().split('T')[0]} value={invoiceArray[configurationindex].configuration_obj.date}
                                                        onChange={(e) => {
                                                            let temp = invoiceArray.map(a => { return { ...a } })
                                                            temp[configurationindex].configuration_obj.date = e.target.value
                                                            setInvoiceArray(temp)
                                                        }} />
                                                </div>
                                            </div>
                                            <div className="row mb-5">
                                                <div className="col-md-12 my-2">
                                                    <label className="fs-5 fw-bold mb-2">Notes</label>
                                                    <textarea className="form-control form-control-solid" rows="3" value={invoiceArray[configurationindex].configuration_obj.notes}
                                                        onChange={(e) => {
                                                            let temp = invoiceArray.map(a => { return { ...a } })
                                                            temp[configurationindex].configuration_obj.notes = e.target.value
                                                            setInvoiceArray(temp)
                                                        }}
                                                        placeholder={""}>
                                                    </textarea>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        invoiceArray[configurationindex].payment_mode == "Credit Card" ?
                                            <>
                                                <div className="row mb-5">
                                                    <div className="col-md-5">
                                                        <label className="required fs-5 fw-bold mb-2">Reference Number</label>
                                                        <input type="text" className="form-control form-control-solid" value={invoiceArray[configurationindex].configuration_obj.ref_number}
                                                            onChange={(e) => {
                                                                let temp = invoiceArray.map(a => { return { ...a } })
                                                                temp[configurationindex].configuration_obj.ref_number = e.target.value
                                                                setInvoiceArray(temp)
                                                            }} />
                                                    </div>
                                                    <div className="col-md-5">
                                                        <label className="required fs-5 fw-bold mb-2">CVV</label>
                                                        <input type="text" className="form-control form-control-solid" value={invoiceArray[configurationindex].configuration_obj.cvv}
                                                            onChange={(e) => {
                                                                let temp = invoiceArray.map(a => { return { ...a } })
                                                                temp[configurationindex].configuration_obj.cvv = e.target.value
                                                                setInvoiceArray(temp)
                                                            }} />
                                                    </div>
                                                </div>
                                                <div className="row mb-5">
                                                    <div className="col-md-10">
                                                        <label className="required fs-5 fw-bold mb-2">Card Type</label>
                                                        <Select
                                                            styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                            name="category"
                                                            id="category"
                                                            options={creditcardlist}
                                                            onChange={(val) => {
                                                                let temp = invoiceArray.map(a => { return { ...a } })
                                                                temp[configurationindex].configuration_obj.card_type = val.value
                                                                setInvoiceArray(temp)
                                                            }}
                                                            value={{ label: invoiceArray[configurationindex].configuration_obj.card_type, value: invoiceArray[configurationindex].configuration_obj.card_type }}
                                                            placeholder="--Choose a Type--"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mb-5">
                                                    <div className="col-md-12 my-2">
                                                        <label className="fs-5 fw-bold mb-2">Notes</label>
                                                        <textarea className="form-control form-control-solid" rows="3" value={invoiceArray[configurationindex].configuration_obj.notes}
                                                            onChange={(e) => {
                                                                let temp = invoiceArray.map(a => { return { ...a } })
                                                                temp[configurationindex].configuration_obj.notes = e.target.value
                                                                setInvoiceArray(temp)
                                                            }}
                                                            placeholder={""}>
                                                        </textarea>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            invoiceArray[configurationindex].payment_mode == "Debit Card" ?
                                                <>
                                                    <div className="row mb-5">
                                                        <div className="col-md-5">
                                                            <label className="required fs-5 fw-bold mb-2">Reference Number</label>
                                                            <input type="text" className="form-control form-control-solid" value={invoiceArray[configurationindex].configuration_obj.ref_number}
                                                                onChange={(e) => {
                                                                    let temp = invoiceArray.map(a => { return { ...a } })
                                                                    temp[configurationindex].configuration_obj.ref_number = e.target.value
                                                                    setInvoiceArray(temp)
                                                                }} />
                                                        </div>

                                                        <div className="col-md-5">
                                                            <label className="required fs-5 fw-bold mb-2">CVV</label>
                                                            <input type="text" className="form-control form-control-solid" value={invoiceArray[configurationindex].configuration_obj.cvv}
                                                                onChange={(e) => {
                                                                    let temp = invoiceArray.map(a => { return { ...a } })
                                                                    temp[configurationindex].configuration_obj.cvv = e.target.value
                                                                    setInvoiceArray(temp)
                                                                }} />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-5">
                                                        <div className="col-md-10">
                                                            <label className="required fs-5 fw-bold mb-2">Card Type</label>
                                                            <Select
                                                                styles={theme == 'dark' ? dropdownStyleDark : {}}
                                                                name="category"
                                                                id="category"
                                                                options={debitcardlist}
                                                                onChange={(val) => {
                                                                    let temp = invoiceArray.map(a => { return { ...a } })
                                                                    temp[configurationindex].configuration_obj.card_type = val.value
                                                                    setInvoiceArray(temp)
                                                                }}
                                                                value={{ label: invoiceArray[configurationindex].configuration_obj.card_type, value: invoiceArray[configurationindex].configuration_obj.card_type }}
                                                                placeholder="--Choose a Type--"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-5">
                                                        <div className="col-md-12 my-2">
                                                            <label className="fs-5 fw-bold mb-2">Notes</label>
                                                            <textarea className="form-control form-control-solid" rows="3" value={invoiceArray[configurationindex].configuration_obj.notes}
                                                                onChange={(e) => {
                                                                    let temp = invoiceArray.map(a => { return { ...a } })
                                                                    temp[configurationindex].configuration_obj.notes = e.target.value
                                                                    setInvoiceArray(temp)
                                                                }}
                                                                placeholder={""}>
                                                            </textarea>
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                invoiceArray[configurationindex].payment_mode == "UPI" &&
                                                <>
                                                    <div className="col-md-5">
                                                        <label className="required fs-5 fw-bold mb-2">Transaction Ref. ID</label>
                                                        <input type="text" className="form-control form-control-solid" value={invoiceArray[configurationindex].configuration_obj.transaction_id}
                                                            onChange={(e) => {
                                                                let temp = invoiceArray.map(a => { return { ...a } })
                                                                temp[configurationindex].configuration_obj.transaction_id = e.target.value
                                                                setInvoiceArray(temp)
                                                            }} />
                                                    </div>
                                                    <div className="row mb-5">
                                                        <div className="col-md-12 my-2">
                                                            <label className="fs-5 fw-bold mb-2">Notes</label>
                                                            <textarea className="form-control form-control-solid" rows="3" value={invoiceArray[configurationindex].configuration_obj.notes}
                                                                onChange={(e) => {
                                                                    let temp = invoiceArray.map(a => { return { ...a } })
                                                                    temp[configurationindex].configuration_obj.notes = e.target.value
                                                                    setInvoiceArray(temp)
                                                                }}
                                                                placeholder={""}>
                                                            </textarea>
                                                        </div>
                                                    </div>
                                                </>
                            }
                        </div>}
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary rounded me-auto" onClick={() => { load_configuration_info(PaymentMode.value, configurationindex); }}>Reset</button>
                    <button className="btn btn-success rounded" onClick={() => { setConfigurationModalShow(false); }}>Save</button>
                </Modal.Footer>
            </Modal>

            <Modal show={gstinModalShow} onHide={() => { handleGstinModalClose() }} centered>
                <Modal.Header>
                    <Modal.Title>Gstin List</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleGstinModalClose() }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: "#f4f6f9" }}>
                    <div className='container'>
                        {
                            gstinListApiState ? <div className='d-flex justify-content-center'><div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} ></div></div> :
                                gstinList.length === 0 ?
                                    <div className="overflow-auto pb-5">
                                        <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed min-w-lg-600px flex-shrink-0 p-6">
                                            <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.3" d="M19.0687 17.9688H11.0687C10.4687 17.9688 10.0687 18.3687 10.0687 18.9688V19.9688C10.0687 20.5687 10.4687 20.9688 11.0687 20.9688H19.0687C19.6687 20.9688 20.0687 20.5687 20.0687 19.9688V18.9688C20.0687 18.3687 19.6687 17.9688 19.0687 17.9688Z" fill="currentColor"></path>
                                                    <path d="M4.06875 17.9688C3.86875 17.9688 3.66874 17.8688 3.46874 17.7688C2.96874 17.4688 2.86875 16.8688 3.16875 16.3688L6.76874 10.9688L3.16875 5.56876C2.86875 5.06876 2.96874 4.46873 3.46874 4.16873C3.96874 3.86873 4.56875 3.96878 4.86875 4.46878L8.86875 10.4688C9.06875 10.7688 9.06875 11.2688 8.86875 11.5688L4.86875 17.5688C4.66875 17.7688 4.36875 17.9688 4.06875 17.9688Z" fill="currentColor"></path>
                                                </svg>
                                            </span>
                                            <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                                                <div className="mb-3 mb-md-0 fw-semibold">
                                                    <h4 className="text-gray-900 fw-bold">No Data Available.</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="d-flex flex-column gap-5">
                                        {
                                            gstinList.sort((a, b) => a.add_date_time - b.add_date_time).map((obj, index) => {
                                                return (
                                                    <div key={index} className="position-relative fv-row w-100 flex-md-root" style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            if (Payment_Type == "Invoice Payment") {
                                                                let t = invoiceArray.map(x => { return { ...x } })
                                                                t[invoiceIndexGstin].gstin_details = obj
                                                                setInvoiceArray(t);
                                                            }
                                                            else {
                                                                setSelectedGstin(obj);
                                                            }
                                                            handleGstinModalClose();
                                                        }}>
                                                        <div className="card card-flush h-lg-100">
                                                            <div className="card-header">
                                                                <div className="card-title"><h3 className="fw-bolder mb-1">{obj.GstIn}</h3></div>
                                                            </div>
                                                            <div className="d-flex flex-wrap">
                                                                <div className="card-body p-9">
                                                                    <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                        <div className="fs-6 fw-bold text-gray-700">{obj.legal_name}</div>
                                                                        <div className="fw-semibold text-gray-400">Business Legal Name</div>
                                                                    </div>
                                                                    <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                        <div className="fs-6 fw-bold text-gray-700">{obj.gst_treatment}</div>
                                                                        <div className="fw-semibold text-gray-400">GST Treatment</div>
                                                                    </div>
                                                                    <div className="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
                                                                        <div className="fs-6 fw-bold text-gray-700">{obj.place_of_supply}</div>
                                                                        <div className="fw-semibold text-gray-400">Place of Supply</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {
                                                            gstinId === obj.unique_id &&
                                                            <div className='position-absolute' style={{ top: "1.5rem", right: "2rem" }} >
                                                                <svg width="30" height="30" viewBox="0 0 64 64">
                                                                    <path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50  l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047" />
                                                                </svg>
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { handleGstinModalClose() }}>Close</button>
                </Modal.Footer>
            </Modal>

            <Modal show={upsertGstInModalShow} onHide={() => { setUpsertGstInModalShow(false); setUpsertGstInId(""); setUpsertGstInTreatment(null); setUpsertGstInNumber(""); setUpsertGstInLegalName(""); setUpsertGstInTradeName(""); setUpsertGstInSelectedPlaceOfSupply(null); }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Add GstIn Details</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setUpsertGstInModalShow(false); setUpsertGstInId(""); setUpsertGstInTreatment(null); setUpsertGstInNumber(""); setUpsertGstInLegalName(""); setUpsertGstInTradeName(""); setUpsertGstInSelectedPlaceOfSupply(null); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <div className="d-flex flex-wrap gap-5 mb-2">
                            <div className="fv-row w-100 flex-md-root">
                                <label className="form-label">GST Treatment</label>
                                <Select
                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                    options={upsertGstInTreatmentList}
                                    value={upsertGstInTreatment}
                                    onChange={(val) => { setUpsertGstInTreatment(val) }}
                                    components={{
                                        Option: (props) => {
                                            return (
                                                <components.Option  {...props}>
                                                    {props.children}
                                                    <span className="fw-semibold text-gray-400 d-block fs-8">{props.data.description}</span>
                                                </components.Option >
                                            )
                                        }
                                    }}
                                />
                            </div>

                        </div>
                        <div className="d-flex flex-wrap gap-5">

                            <div className="fv-row w-100 flex-md-root">
                                <label className="required form-label">GSTIN</label>
                                <input id="GSTIN" type="text" className="form-control mb-2" placeholder="" name="GSTIN" value={upsertGstInNumber} onChange={(e) => { setUpsertGstInNumber(e.target.value) }} />
                            </div>
                            <div className="fv-row w-100 flex-md-root">
                                <label className="required form-label">Business Legal Name</label>
                                <input id="Business_Legal_Name" type="text" className="form-control mb-2" placeholder="" name="Business_Legal_Name" value={upsertGstInLegalName} onChange={(e) => { setUpsertGstInLegalName(e.target.value) }} />
                            </div>

                        </div>
                        <div className="d-flex flex-wrap gap-5">
                            <div className="fv-row w-100 flex-md-root">
                                <label className="required form-label">Place Of Supply</label>
                                <Select
                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                    options={SupplyStateOptions}
                                    onChange={(val) => { setUpsertGstInSelectedPlaceOfSupply(val) }}
                                    value={upsertGstInSelectedPlaceOfSupply}
                                    isClearable
                                />
                            </div>
                            <div className="fv-row w-100 flex-md-root">
                                <label className="form-label">Business Trade Name</label>
                                <input id="Business_Trade_Name" type="text" className="form-control mb-2" placeholder="" name="Business_Trade_Name" value={upsertGstInTradeName} onChange={(e) => { setUpsertGstInTradeName(e.target.value) }} />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setUpsertGstInModalShow(false); setUpsertGstInId(""); setUpsertGstInTreatment(null); setUpsertGstInNumber(""); setUpsertGstInLegalName(""); setUpsertGstInTradeName(""); setUpsertGstInSelectedPlaceOfSupply(null); }}>Close</button>
                    {
                        write &&
                        <button className="btn btn-info rounded" data-kt-indicator={upsertGstInSubmitButtonState ? "on" : "off"} disabled={upsertGstInSubmitButtonState} onClick={() => { newGstInSubmit() }}>
                            <span className="indicator-label">Save</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>
            <Drawer width={window.innerWidth > 1200 ? 800 : 'auto'} styles={{ body: { padding: "1.5rem" } }} onClose={onClose} open={open} closeIcon={<a onClick={onClose}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z" /><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z" /></svg>
            </a>}
                extra={
                    <Space>

                    </Space>
                }
            >
                <div className="card">
                    <div className="d-flex w-100 overflow-auto">
                        <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                            <li className="nav-item mx-lg-1">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Product_details" && "active"}`} onClick={(e) => { setnavtype("Product_details"); }}>Product Details</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Invoice History" && "active"}`} onClick={(e) => { setnavtype("Invoice History"); }}>Invoice History</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Payment History" && "active"}`} onClick={(e) => { setnavtype("Payment History"); }}>Payment History</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="card">
                    {(navtype === "Overview") ?
                        <>
                            <div
                                className="card border-primary mb-3 mt-2"
                                style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}
                            >
                                <div className="card-header cursor-pointer py-3">
                                    <div className="card-title m-0">
                                        {customerInvoiceDetails !== null &&
                                            <h3 className="fw-bold m-0">
                                                #{customerInvoiceDetails.customer_invoice_number}
                                            </h3>
                                        }
                                    </div>
                                </div>
                                <div className="card-body p-3">
                                    {(additonalDetailsFlag !== true && customerInvoiceDetails !== null) ?
                                        <>
                                            <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Invoice Date</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {/* {financerDetails.order_number} */}
                                                            {moment(customerInvoiceDetails.invoice_date).format("ll")}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Due Date</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {moment(customerInvoiceDetails.due_date).format("ll")}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Internal Notes</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {customerInvoiceDetails.internal_notes !== "" ? customerInvoiceDetails.internal_notes : "No notes provided"}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Term</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {customerInvoiceDetails.term == null ? "No term period added" : (customerInvoiceDetails.term.term_name + "---" + customerInvoiceDetails.term.term_days + " days")}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Terms and Conditions</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {customerInvoiceDetails.terms_and_conditions !== "" ? customerInvoiceDetails.terms_and_conditions : "No terms and conditions provided"}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Status</label>
                                                    <div className="col-lg-8">{console.log("customerInvoiceDetails", customerInvoiceDetails)}
                                                        <div style={{ position: "relative", display: "inline-block" }} >
                                                            <button className={`py-2 me-1 rounded btn btn-sm btn-${customerInvoiceDetails.add_status === "CUSTOMER_INVOICE_PENDING_APPROVAL" ? "warning" : "secondary"}`} onClick={() => { setApprovalChainPopup(true); }} onBlur={() => { setApprovalChainPopup(false) }}>
                                                                {customerInvoiceDetails.add_status.replace("CUSTOMER_INVOICE", "").toLowerCase().replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}
                                                            </button>
                                                            <div style={{ position: "absolute", right: "0px", top: "0px", boxShadow: "0 2px 5px 0 rgb(0 0 0 / 26%)", backgroundColor: "#FFFFFF", color: "black", padding: "1rem", width: "25rem", borderRadius: "0.5rem", transition: "all 0.25s ease-in-out", zIndex: 1, opacity: approvalChainPopup ? "1" : "0", visibility: approvalChainPopup ? "visible" : "hidden" }}>
                                                                {
                                                                    customerInvoiceDetails.approval_info.type === "multilevel_approval" ?
                                                                        <>
                                                                            <div className='text-center border-bottom fs-4'>Multilevel Approval</div>
                                                                            <div>
                                                                                {
                                                                                    customerInvoiceDetails.approval_info.value.map((obj, i) => {
                                                                                        return (
                                                                                            <div key={i} className='mx-auto mt-2 gap-5' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px", position: "relative", marginBottom: "30px" }}>
                                                                                                <div style={{ width: "30px", height: "30px", border: "5px #ffc700 solid", borderRadius: "10px" }}></div>
                                                                                                <div className='flex-grow-1 text-start'>
                                                                                                    <div className='fs-4'>Level {obj.level}</div>
                                                                                                    {
                                                                                                        obj.user_value.map((val, j) => {
                                                                                                            return <div key={j} className="fs-7"><span className='bullet bg-primary me-2'></span>{val}</div>
                                                                                                        })
                                                                                                    }
                                                                                                </div>
                                                                                                <div style={{ position: "absolute", width: "2px", height: "30px", backgroundColor: "darkgray", top: "100%", left: "24px" }}></div>
                                                                                            </div>
                                                                                        )
                                                                                    })
                                                                                }

                                                                                <div className='mx-auto my-2 gap-20' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px" }}>
                                                                                    <i className="fa-solid fa-star fs-1" style={{ color: "#ff8100" }} ></i>
                                                                                    <div className='fs-4'>Approved</div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                        :
                                                                        customerInvoiceDetails.approval_info.type === "custom_approval" &&
                                                                        <>
                                                                            <div className='text-center border-bottom fs-4'>Custom Approval</div>
                                                                            <div>
                                                                                <div className='mx-auto mt-2 gap-5' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px", position: "relative", marginBottom: "30px" }}>
                                                                                    <div style={{ width: "30px", height: "30px", border: "5px #ffc700 solid", borderRadius: "10px" }}></div>
                                                                                    <div className='flex-grow-1 text-start'>
                                                                                        <div className='fs-4'>{customerInvoiceDetails.approval_info.value[0].user_type}</div>
                                                                                        {
                                                                                            customerInvoiceDetails.approval_info.value[0].user_value.map((val, i) => {
                                                                                                return <div key={i} className="fs-7"><span className='bullet bg-primary me-2'></span>{val}</div>
                                                                                            })
                                                                                        }
                                                                                    </div>
                                                                                    <div style={{ position: "absolute", width: "2px", height: "30px", backgroundColor: "darkgray", top: "100%", left: "24px" }}></div>
                                                                                </div>
                                                                                <div className='mx-auto my-2 gap-20' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px" }}>
                                                                                    <i className="fa-solid fa-star fs-1" style={{ color: "#ff8100" }} ></i>
                                                                                    <div className='fs-4'>Approved</div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                <h5 className="fw-bold mb-3">Customer Details</h5>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Customer Name</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {customerInvoiceDetails.customer_name}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Customer Email</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {customerInvoiceDetails.customer_email}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Work Phone</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {customerInvoiceDetails.customer_workphone}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                <h5 className="fw-bold mb-3">Address Details</h5>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Billing Address</label>
                                                    <div className="col-lg-8">
                                                        <div className="location">
                                                            <i className="fas fa-map-marker-alt"></i> {customerInvoiceDetails.billing_address.city}, {customerInvoiceDetails.billing_address.state}
                                                        </div>
                                                        <div className="pincode">
                                                            <i className="fas fa-thumbtack"></i> {customerInvoiceDetails.billing_address.pincode}
                                                        </div>
                                                        <div className="country">
                                                            <i className="fas fa-globe"></i> {customerInvoiceDetails.billing_address.country}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Shipping Address</label>
                                                    <div className="col-lg-8">
                                                        <div className="location">
                                                            <i className="fas fa-map-marker-alt"></i> {customerInvoiceDetails.shipping_address.city}, {customerInvoiceDetails.shipping_address.state}
                                                        </div>
                                                        <div className="pincode">
                                                            <i className="fas fa-thumbtack"></i> {customerInvoiceDetails.shipping_address.pincode}
                                                        </div>
                                                        <div className="country">
                                                            <i className="fas fa-globe"></i> {customerInvoiceDetails.shipping_address.country}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                <h5 className="fw-bold mb-3">Other Details</h5>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Branch</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {customerInvoiceDetails.branch_name}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Place Of Supply</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {customerInvoiceDetails.place_of_supply}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <label className="col-lg-4 fw-semibold text-muted">Currency</label>
                                                    <div className="col-lg-8">
                                                        <span className="fw-bold fs-6 text-gray-800">
                                                            {customerInvoiceDetails.invoice_currency.currency_code}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                    }
                                </div>
                            </div>
                        </>
                        :
                        navtype === "Product_details" ?
                            <>
                                <div className="card border-primary mb-3 mt-2" style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}>
                                    {(additonalDetailsFlag !== true && customerInvoiceDetails !== null) ?
                                        <>
                                            <div className="card-body p-9">
                                                <div>
                                                    {customerInvoiceDetails.item_array.length > 0 && customerInvoiceDetails.item_array.map((item, indx4) => {
                                                        return (
                                                            <div className="payment-details-box" key={indx4} style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Product Name</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {item.item_name}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Rate</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {baseCurrency.currency_symbol} {item.rate}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Quantity</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {item.quantity}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-2">
                                                                    <label className="col-lg-4 fw-semibold text-muted">Total</label>
                                                                    <div className="col-lg-8">
                                                                        <span className="fw-bold fs-6 text-gray-800">
                                                                            {customerInvoiceDetails.invoice_currency.currency_symbol} {Math.round((((item.quantity * item.rate) - (item.discount_type === "amount" ? item.discount_unit : item.quantity * item.rate * item.discount_unit / 100)) + (item.taxable === 0 ? 0 : ((item.quantity * item.rate) - (item.discount_type === "amount" ? item.discount_unit : item.quantity * item.rate * item.discount_unit / 100)) * (item.tax_group_percentage / 100))) * customerInvoiceDetails.invoice_currency.decimal_place) / customerInvoiceDetails.invoice_currency.decimal_place}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                    }
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                    }
                                </div>
                            </>
                            :
                            navtype === "Invoice History" ?
                                <>
                                    {(additonalDetailsFlag !== true) ?
                                        <div className="card-body p-9">
                                            {customerInvoiceHistoryDetails.length > 0 && customerInvoiceHistoryDetails.map((obj, index) => {
                                                return (
                                                    <>
                                                        <div key={index} className="m-0">
                                                            <div className="d-flex align-items-sm-center mb-5">
                                                                <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                                                                    <div className="flex-grow-1 me-2">
                                                                        {obj.customer_invoice_status === "CUSTOMER_INVOICE_DRAFT" ? <span className="badge badge-lg badge-secondary fw-bold my-2">Draft</span> : obj.customer_invoice_status === "CUSTOMER_INVOICE_CANCELLED" ? <span className="badge badge-lg badge-danger fw-bold my-2">Cancelled</span> : obj.customer_invoice_status === "CUSTOMER_INVOICE_PENDING_APPROVAL" ? <><span className="badge badge-lg badge-warning fw-bold my-2">Pending Approval</span></> : obj.customer_invoice_status === "CUSTOMER_INVOICE_CONFIRMED" ? <span className="badge badge-lg badge-success fw-bold my-2">Confirmed</span> : obj.customer_invoice_status === "CUSTOMER_INVOICE_FINALIZED" ? <span className="badge badge-lg badge-success fw-bold my-2">Finalized</span> : <span className="badge badge-lg badge-danger fw-bold my-2">{obj.customer_invoice_status.replace("CUSTOMER_INVOICE_", "").toLowerCase().replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}</span>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="timeline">
                                                                <div className="timeline-item align-items-center mb-7">
                                                                    <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                                    <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                                        <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                                        <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                                    </svg>
                                                                    </span>
                                                                    <div className="timeline-content m-0">
                                                                        <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                                        <span className="fs-6 fw-bold text-gray-800">{moment(obj.timestamp).format("lll")} </span>
                                                                    </div>
                                                                </div>
                                                                <div className="timeline-item align-items-center">
                                                                    <div className="timeline-line w-40px"></div>
                                                                    <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                                        <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                                        <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                                    </svg>
                                                                    </span>
                                                                    <div className="timeline-content m-0">
                                                                        <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                                        <span className="fs-6 fw-bold text-gray-800">{obj.user}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {customerInvoiceHistoryDetails.length > 1 &&
                                                            <div className="separator separator-dashed my-6"></div>
                                                        }
                                                    </>
                                                )
                                            })}
                                        </div>
                                        :
                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                    }
                                </> :
                                navtype === "Payment History" &&
                                <>
                                    <div className="card border-primary mb-3 mt-2" style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}>
                                        {(additonalDetailsFlag !== true && customerInvoiceDetails !== null) ?
                                            <>
                                                <div className="card-body p-9">
                                                    <div>
                                                        {customerInvoiceDetails.payment_logs.length == 0 ?
                                                            <span className='text-gray-600'>No history available.</span>
                                                            :
                                                            customerInvoiceDetails.payment_logs.map((item, indx4) => {
                                                                return (
                                                                    <div className="payment-details-box" key={indx4} style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                                                        <div className="row mb-2">
                                                                            <label className="col-lg-4 fw-semibold text-muted">Status</label>
                                                                            <div className="col-lg-8">
                                                                                <StatusBadge status={item.log_status} entity={""} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="row mb-2">
                                                                            <label className="col-lg-4 fw-semibold text-muted">timestamp</label>
                                                                            <div className="col-lg-8">
                                                                                <span className="fw-bold fs-6 text-gray-800">
                                                                                    {moment(item.log_date_time).format("lll")}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row mb-2">
                                                                            <label className="col-lg-4 fw-semibold text-muted">Amount</label>
                                                                            <div className="col-lg-8">
                                                                                <span className="fw-bold fs-6 text-gray-800">
                                                                                    {customerInvoiceDetails.invoice_currency.currency_symbol} {item.payment_amount}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                        }
                                    </div>
                                </>
                    }
                </div>
            </Drawer>
        </>);

};

export default EditPaymentReceived;
